<template>
  <div class="form-wrapper">
    <div v-if="this.$route.params.id && (this.$route.query.type === false || this.$route.query.type === 'false')" class="p-24 form-header-styling">
      <a data-v-095e4038="" href="/layout/registration" class="d-flex router-link-active">
        <img data-v-095e4038="" src="/static/images/icons/emergo_right_chevron.svg" alt="">
        <div data-v-095e4038="" class="fw-400 form-header-styling form-header-text primary-default-text-color"> {{ $t('editCertificate') }} </div>
    </a>
    </div>
    <div v-if="!this.$route.params.id && (this.$route.query.type === false || this.$route.query.type === 'false')" class="p-24 form-header-styling">
      <a data-v-095e4038="" href="/layout/registration" class="d-flex router-link-active">
        <img data-v-095e4038="" src="/static/images/icons/emergo_right_chevron.svg" alt="">
        <div data-v-095e4038="" class="fw-400 form-header-styling form-header-text primary-default-text-color"> {{ $t('addCertificate') }} </div>
    </a>
    </div>
    <div class="col-xs-12 p-40 form-wrapper">
    <div class="col-xs-12 form-fields-wrapper">
      <div class="col-xs-12 p-0 p-relative h-100">
        <div class="row p-0 m-0 pb-109 add-record-fields">
          <div class="col-xs-12 p-0 mb-32">
            <p class="mb-0 fw-600 font-18 enterFollowingDetails primary-default-text-color">{{ $t('enterFollowingDetailsMessage') }}:</p>
            <p class="mb-16 font-16 emergo-dark-gray enterFollowingDetailsNote primary-default-text-color">{{ $t('addRecordNote') }}</p>
            <span class="required-field-text">( * = {{ $t('requiredField') }})</span>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-sm-12 col-xs-12 pl-0 pr-0 d-flex col-gap-56 xs-flex-column align-items-start">
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                <div class="label_name asterisk">{{ $t('manufacturer') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.manufacturer"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterManufacturer')"
                    v-model="selectedCompany"
                    maxlength="255"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right brand-name-section">
                <div class="label_name">{{ $t('brandName') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.localDistributor"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterBrandName')"
                    v-model="selectedLocalDistributor"
                    maxlength="255"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 p-0">
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-28 xs-pr-0 left">
              <div class="label_name asterisk">{{ $t('countryOfOrigin') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.registeringCountry"></excel-info-popover>
                <multiselect
                  class="product-class-ellipsis multiselect-single-dropdown ml-12 width z-index-8"
                  :placeholder="$t('selectCountry')"
                  label="country_name" track-by="country_name"
                  openDirection="below"
                  v-model="selectedCountry"
                  :show-labels="false"
                  :options="countryList"
                  @select="onCountrySelect"
                >
                  <span slot="noResult">{{ $t('noElementsFound') }}</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-28 xs-pl-0 pr-0 right custom-tooltip-record">
              <div class="label_name asterisk">{{ $t('ManufacturingAddress') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.manufacturingAddress"></excel-info-popover>
                <multiselect
                  class="manufacturing-address multiselect-single-dropdown  ml-12 width z-index-8"
                  :placeholder="$t('selectManufacturingAddress')"
                  openDirection="below"
                  :allow-empty="false"
                  :show-labels="false"
                  :searchable="true"
                  :options="multiPlantAddresses.map((product) => product.plantLocationId)"
                  :custom-label="
                    (opt) => multiPlantAddresses.find((x) => x.plantLocationId === opt).addressDetails || ''
                  "
                  v-model="selectedManufacturingAddress"
                  @select="addAddress($event)"
                >
                  <span slot="noOptions">{{ $t('manuFacturingAddressEmptyMessage') }}</span>
                  <span slot="noResult">{{ $t('noElementsFound') }}</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left partNumberSection">
              <div class="label_name">{{ $t('barcodes') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.devicePartNumber"></excel-info-popover>
                <v-select-part
                  :options="multiPartOptions"
                  :class="multiPartOptions.length === 0 ? 'border-required' : ''"
                  multiple
                  allowToAddItem
                  :searchable="true"
                  class="ml-12"
                  v-model="multiPartValue"
                  style="width: 100%"
                  :close-on-select="true"
                  label="multi"
                  :placeholder="$t('enterPartNumber')"
                  :autocomplete="true"
                  :maxlength=50
                ></v-select-part>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
              <div class="label_name asterisk">{{ $t('productName') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.productName"></excel-info-popover>
                <input
                  type="text"
                  :disabled="($route.params.id && !isSaveDraft) && ($route.params.id && !invalidRecord)"
                  class="form-control ellipsis"
                  :placeholder="$t('enterProductName')"
                  v-model="selectedProduct"
                  maxlength="255"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
              <div class="label_name asterisk">{{ $t('modelName') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.deviceUDI"></excel-info-popover>
                <v-select-part
                  multiple
                  allowToAddItem
                  class="ml-12"
                  v-model="deviceUdi"
                  style="width: 100%"
                  :close-on-select="true"
                  label="multi"
                  :placeholder="$t('enterModelName')"
                  :maxlength=50
                ></v-select-part>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
              <div class="label_name asterisk">{{ $t('productCategory') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.productCategory"></excel-info-popover>
                <multiselect
                  class="product-class-ellipsis multiselect-single-dropdown ml-12 z-index-4"
                  :placeholder="$t('selectProductCategory')"
                  label="name" track-by="name"
                  openDirection="below"
                  v-model="selectedRegistrationType"
                  :show-labels="false"
                  :options="registrationTypeList"
                  @select="onRegistrationTypeSelect"
                  :disabled="editRecord && !isSaveDraft && !invalidRecord"
                >
                  <span slot="noResult">{{ $t('noElementsFound') }}</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 p-0">
            <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left single-field">
              <div class="label_name asterisk">{{ $t('productClass') }}</div>
              <div class="field-section">
                <excel-info-popover :info="translatedExcelColumnInfo.deviceClass"></excel-info-popover>
                <multiselect
                  :disabled="disableProductClass || editRecord && !isSaveDraft && !invalidRecord"
                  :show-labels="false"
                  openDirection="below"
                  :options="deviceClassList"
                  :placeholder="$t('selectDeviceClass')"
                  v-model="selectedDeviceClass"
                  class="product-class-ellipsis multiselect-single-dropdown ml-12 width z-index-8"
                  @OpenWith="AddOtherOption(selectedDeviceClass)"
                  @select="onProductClassSelect"
                >
                  <span slot="noOptions">{{ $t('listEmpty') }}</span>
                  <span slot="noResult">{{ $t('noElementsFound') }}</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0 text-area description-section">
            <div class="col-sm-12 col-xs-12 pl-0 pr-0 form-group left">
              <div class="label_name">{{ $t('description') }}</div>
              <div class="field-section description-flex-start">
                <excel-info-popover :info="translatedExcelColumnInfo.configuration"></excel-info-popover>
                <textarea
                  type="text"
                  class="form-control ellipsis"
                  :placeholder="$t('enterDescription')"
                  v-model="configuration"
                  maxlength="255"
                  style="min-height: 100px;"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0 form-separator"></div>
          <div v-if="todo_checklist_complete && ($route.query.type === false || $route.query.type === 'false')">
            <div class="col-xs-12 p-0">
              <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                  <div class="label_name asterisk">{{ $t('certificationNumber') }}</div>
                  <div class="field-section">
                    <excel-info-popover :info="translatedExcelColumnInfo.submissionNumber"></excel-info-popover>
                    <input
                      type="text"
                      class="form-control ellipsis"
                      :placeholder="$t('enterCertificationNumber')"
                      v-model="submissionNumber"
                      maxlength="255"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                  <div class="label_name">{{ $t('certificationURL') }}</div>
                  <div class="field-section">
                    <excel-info-popover :info="translatedExcelColumnInfo.registrationNumber"></excel-info-popover>
                    <input
                      type="text"
                      class="form-control ellipsis"
                      maxlength="255"
                      :placeholder="$t('enterCertificationURL')"
                      v-model="registrationNumber"
                      @blur="checkValidUrl"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-sm-12 col-xs-12 p-0 d-flex align-items-start xs-flex-column">
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-28 xs-pr-0 left">
                  <div class="label_name asterisk">{{ $t('managedBy') }}</div>
                  <div class="field-section">
                    <excel-info-popover :info="translatedExcelColumnInfo.localRepresentative"></excel-info-popover>
                    <multiselect
                      :show-labels="false"
                      :options="managedByList"
                      openDirection="below"
                      :placeholder="$t('selectManagedBy')"
                      v-model="selectedLocalRepresentative"
                      class="product-class-ellipsis multiselect-single-dropdown ml-12 width z-index-1"
                      ><span slot="noResult">{{ $t('noElementsFound') }}</span></multiselect
                    >
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-28 xs-pl-0 pr-0 custom-tooltip-record right">
                  <div class="label_name">{{ $t('accreditedBy') }}</div>
                  <div class="field-section">
                    <excel-info-popover :info="translatedExcelColumnInfo.issuedBy"></excel-info-popover>
                    <multiselect
                      :show-labels="false"
                      openDirection="below"
                      :options="certificateIssuedByList"
                      :placeholder="$t('enterIssuerName')"
                      v-model="issuedBy"
                      class="accredited-by-ellipsis multiselect-single-dropdown ml-12 width z-index-1"
                      ><span slot="noResult">{{ $t('noElementsFound') }}</span></multiselect
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-sm-12 col-xs-12 p-0 d-flex align-items-start col-gap-56 xs-flex-column">
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                  <div class="label_name">{{ $t('registrationDate') }}</div>
                  <div class="field-section date-fields">
                    <excel-info-popover :info="translatedExcelColumnInfo.submissionDate"></excel-info-popover>
                    <date-picker
                      :popup-style="{ top: '100%', left: 0}"
                      :append-to-body="false"
                      v-model="submissionDate"
                      :default-value="submissionDate ? submissionDate : new Date()"
                      :editable="true"
                      :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
                      class="ml-12"
                      :format="this.$i18n.locale === 'English' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'"
                      type="date"
                      :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
                      :disabled-date="disableDateBeforeToday"
                      :disabled="true"
                    >
                      <i slot="icon-calendar">
                        <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon" /> </i
                    ></date-picker>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                  <div class="label_name asterisk">{{ $t('dateOfIssue') }}</div>
                  <div class="field-section date-fields">
                    <excel-info-popover :info="translatedExcelColumnInfo.registrationApprovalDate"></excel-info-popover>
                    <date-picker
                      v-model="approvalDate"
                      :popup-style="{ top: '100%', left: 0}"
                      :append-to-body="false"
                      class="ml-12"
                      type="date"
                      :placement="'left'"
                      :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
                      :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
                      :default-value="approvalDate ? approvalDate : new Date()"
                      :editable="true"
                      :format="validateIssueDate"
                      @change="issueDateUpdate"
                      :disabled="
                        editRecord &&
                        (this.selectedRegistration.expiration_date !== null && this.selectedRegistration.expiration_date !== '') && !isSaveDraft && !invalidRecord
                      "
                    >
                      <i slot="icon-calendar">
                        <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon" /> </i
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-sm-12 col-xs-12 p-0 not-approved-field d-flex align-items-start col-gap-56 xs-flex-column">
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                  <div class="label_name">{{ $t('maintenanceDate') }}</div>
                  <div class="field-section date-fields">
                    <excel-info-popover :info="translatedExcelColumnInfo.productFamily"></excel-info-popover>
                    <date-picker
                      :popup-style="{ top: '100%', left: 0}"
                      :append-to-body="false"
                      v-model="selectedProductFamily"
                      type="date"
                      :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
                      :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
                      :default-value="selectedProductFamily ? selectedProductFamily : new Date()"
                      :editable="true"
                      class="ml-12"
                      :format="validateselectedProductFamily"

                    >
                      <i slot="icon-calendar">
                        <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon" /> </i
                    ></date-picker>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                  <div class="label_name asterisk">{{ $t('nextMaintenanceDate') }}</div>
                  <div class="field-section date-fields">
                    <excel-info-popover :info="translatedExcelColumnInfo.maintenanceDate"></excel-info-popover>
                    <date-picker
                      :popup-style="{ top: '100%', left: 0}"
                      :append-to-body="false"
                      v-model="next_maintenance_date"
                      type="date"
                      :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
                      :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
                      :default-value="next_maintenance_date ? next_maintenance_date : new Date()"
                      :editable="true"
                      class="ml-12"
                      :format="validateNextDate"
                      :disabled="disableNextDate"
                      :disabled-date="disableDateBeforeToday"
                      @change="isValidDate"
                    >
                      <i slot="icon-calendar">
                        <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon" /> </i
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column not-approved-field">
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                  <div class="label_name asterisk">{{ $t('dateOfExpiration') }}</div>
                  <div class="field-section date-fields">
                    <excel-info-popover
                      :info="translatedExcelColumnInfo.registrationExpirationDate"
                    ></excel-info-popover>
                    <date-picker
                      :popup-style="{ top: '100%', left: 0}"
                      :append-to-body="false"
                      v-model="expirationDate"
                      class="ml-12"
                      :default-value="expirationDate ? expirationDate : new Date()"
                      :editable="true"
                      :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
                      type="date"
                      :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
                      :format="validateExpirationDate"
                      :disabled="
                        editRecord &&
                        (this.selectedRegistration.expiration_date !== null && this.selectedRegistration.expiration_date !== '') && !isSaveDraft && !invalidRecord
                      "
                      >
                      <i slot="icon-calendar">
                        <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon" /> </i
                    ></date-picker>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                  <div class="label_name">{{ $t('alertDate') }}</div>
                  <div class="field-section">
                    <excel-info-popover :info="translatedExcelColumnInfo.alertBeforeMonths"></excel-info-popover>
                    <input
                      type="number"
                      min="1"
                      class="form-control ellipsis"
                      :disabled="disableAlertDate"
                      v-model.lazy="alertBeforeMonths"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                <div class="label_name">{{ $t('standardsField') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.standards"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterStandards')"
                    v-model="standards"
                    maxlength="255"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                <div class="label_name">{{ $t('ordinance') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.ordinance"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterOrdinance')"
                    v-model="ordinance"
                    maxlength="255"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                <div class="label_name asterisk">{{ $t('importedProduct') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.importedProduct"></excel-info-popover>
                  <multiselect
                    :show-labels="false"
                    Select
                    Accredited
                    By
                    :options="importedProduct"
                    openDirection="below"
                    :placeholder="$t('enterImportedProduct')"
                    v-model="selectedImportedProduct"
                    class="remove-selected-bg-color multiselect-single-dropdown ml-12 width z-index-1"
                    @select="onImportedProductSelect"
                    ><span slot="noResult">{{ $t('noElementsFound') }}</span></multiselect
                  >
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                <div class="label_name">{{ $t('importer') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.importer"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterImporter')"
                    v-model="importer"
                    maxlength="255"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-sm-12 col-xs-12 p-0 d-flex col-gap-56 align-items-start xs-flex-column">
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 left">
                <div class="label_name">{{ $t('requester') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.requester"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterRequester')"
                    v-model="requester"
                    maxlength="255"
                  />
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-0 right">
                <div class="label_name">{{ $t('tradeRepresentative') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.tradeRepresentative"></excel-info-popover>
                  <input
                    type="text"
                    class="form-control ellipsis"
                    :placeholder="$t('enterTradeRepresentative')"
                    v-model="tradeRepresentative"
                    maxlength="255"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-sm-12 col-xs-12 p-0 d-flex align-items-start xs-flex-column">
              <div class="col-sm-6 col-md-6 col-xs-12 form-group pl-0 pr-28 xs-pr-0 left">
                <div class="label_name asterisk">{{ $t('status') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.newPageStatus"></excel-info-popover>
                  <multiselect
                    :show-labels="false"
                    :options="newPageStatus"
                    openDirection="below"
                    :placeholder="$t('selectStatus')"
                    v-model="inputStatus"
                    class="remove-selected-bg-color multiselect-single-dropdown ml-12 width z-index-1"
                    ><span slot="noResult">{{ $t('noElementsFound') }}</span></multiselect
                  >
                </div>
              </div>
              <div v-if="$route.params.id" class="col-sm-6 col-md-6 col-xs-12 form-group pl-28 xs-pl-0 pr-0 right custom-tooltip-record">
                <div class="label_name">{{ loggedInUser.company }} {{ $t('contact') }}</div>
                <div class="field-section">
                  <excel-info-popover :info="translatedExcelColumnInfo.medCompContact"></excel-info-popover>
                  <multiselect
                    :show-labels="false"
                    :options="medCompContactListByName"
                    openDirection="below"
                    :placeholder="$t('selectContact')"
                    v-model="medCompContact"
                    class="remove-selected-bg-color multiselect-single-dropdown ml-12 width z-index-1"
                    ><span slot="noResult">{{ $t('noElementsFound') }}</span></multiselect
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0 text-area comments-section">
            <div class="col-sm-12 col-xs-12 pl-0 pr-0 form-group left">
              <div class="label_name">{{ $t('comments') }}</div>
              <div class="field-section comments-flex-start">
                <excel-info-popover :info="translatedExcelColumnInfo.comments"></excel-info-popover>
                <textarea
                  class="form-control"
                  :placeholder="$t('enterComments')"
                  v-model="comments"
                  style="min-height: 100px;"
                  maxlength="500"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-xs-12 p-0 form-separator default-search-table"></div>
          <div class="col-xs-12 p-0">
            <DefaultSearchWithTable  :headerText="'Attachments (Optional)'" :tabNames="attachmentTypeList" :tableLabels="['File Name']"
              :filesArray="fileArrayObject[attachmentTypeList[tableActiveTab - 1].tabName]" @tableTabChanged="tabChangedEmit" :activeTab="tableActiveTab" :key="fileArrayObject[attachmentTypeList[tableActiveTab - 1].tabName]? attachmentTypeList[tableActiveTab - 1].tabName+fileArrayObject[attachmentTypeList[tableActiveTab - 1].tabName].length:attachmentTypeList[tableActiveTab - 1].tabName" @uploadTableOperation="openAttachment" @deleteTableOperation="showDeletePopup"  :deleteBtn="deleteBtn"
              @deleteAttachments ="showConfirmationPopup"/>
          </div>
        </div>
      </div>
    </div>
    <add-record-file-upload
        :regiId="registrationId"
        :type="attachmentType"
        :record_attachments="attachments"
        :revision="revision"
        :tableTab="attachmentTypeList[tableActiveTab-1].tabName"
      ></add-record-file-upload>
    <delete-popup
      :headerTitle="headerTitle"
      :deletewarnInfo="deleteWarningInfo"
      :customMessage="deleteWarningInfo.customMessage"
      :confirmMessage="confirmMessage"
      @dashboardPublishDelete="updateRecordsId"
      @closePopup="resetData"
    >
    </delete-popup>
    <generic-popup :genericPopupId="genericPopupId" :genericBody="'Revision'"></generic-popup>
    <record-type-popup NTM="true" @proceedToAddNTMProduct="proceedToAddNTMProduct" @cancelAdd="cancelAdd" :promptMsg="promptMsg"></record-type-popup>
    <add-address :key="render" @updateManufacturingAddress="updateManufacturingAddress" @updatePlantLocation="updatePlantLocation"></add-address>
    <confirmation-popup :title="deleteRecords" :confirmationText="confirmationText"  @proceedChanges="deleteFile"></confirmation-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
  <div class="col-xs-12 d-flex justify-content-end col-gap-16 footer-btns" v-if="$route.query.type === 'false' || $route.query.type === false">
      <button
        type="button"
        class="btn emergo-btn emergo-cancel-button"
        @click="$router.push('/layout/registration')"
      >
        {{ $t('cancel') }}
      </button>
      <button
        v-if="showHideDraftBtn"
        type="button"
        class="btn emergo-btn emergo-secondary-button"
        :disabled="disableSaveAsDraft"
        @click="saveRecordAsDraft(true)"
      >
        {{ $t('saveAsDraft') }}
      </button>
      <button
        type="button"
        class="btn emergo-btn emergo-primary-button"
        @click="checkForNTMProduct(false)"
        :disabled="disableNextStatus"
      >
        {{ $t('submit') }}
      </button>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import { ListSelect } from 'vue-search-select';
import * as moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import Autocomplete from '../UIComponents/AutoComplete.vue';
import AutocompleteDevice from '../UIComponents/AutoCompleteDeviceClass.vue';
import RecordTypePopup from './RecordTypePopup.vue';
import AddAddress from './AddAddress.vue';
import AutocompleteCertificate from '../UIComponents/AutoCompleteCertificate.vue';
import ExcelInfoPopover from '../UIComponents/ExcelInfoPopover.vue';
import vSelectDist from '../UIComponents/SelectDistributor.vue';
import vSelectRecord from '../UIComponents/SelectRecord.vue';
import vSelectPart from '../UIComponents/SelectPartNumber.vue';
import DuplicateConfirmation from '../UIComponents/DuplicateConfirmation.vue';
import GenericPopup from '../UIComponents/GenericPopup.vue';
import { getMultiplantAddress } from '../../apis/multiplantAddress';
import AddRecordFileUpload from './AddRecordFileUpload.vue';
import {
  getMedCompContacts,
  getRegistrationTypeList,
  getCertificateList,
  getProductList,
  getLocalDistributor,
  getProductPartNumber,
  getLocalRepresentative,
  getProductFamily,
  getCertificateIssuerList,
  checkDuplicateRegistration,
  saveRegistrationDetails,
  getProductClass,
  getCountryCertificateAuth,
  getRegistrationDetailsById,
  editRegistration,
  getSubscriptions,
  editBulkRegistration,
  getMaintenanceCyclePerOrdinance,
  getNextMaintenanceDate
} from '../../apis/registrations';
import { getAddonDetails } from '../../apis/psm';
import EventBus from '../../utils/event-bus';
// import FileUploadRegi from '../UIComponents/FileUploadRegi.vue';
// import DownloadRegAttachment from '../UIComponents/mixins/downloadRegAttachment';
import {
  deleteAttachments,
  // updateFile,
  // checkFileConfidentiality,
  getAttachments,
  downloadFile
} from '../../apis/fileUploadDownload';
import DeletePopup from '../UIComponents/DeleteRegHeadlinePopup.vue';
import translation from '../UIComponents/mixins/translationMixins';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import { getAllCountries } from '../../apis/countriesList';
import ConfirmationPopup from '../Common/ULConfirmationPopup.vue';
import DefaultSearchWithTable from '../Common/DefaultSearchWithTable.vue';
// import DefaultULReview from '../Common/DefaultULReview.vue';

export default {
  props: { roleInfo: Object, activeTab: Number, nextBtn: String },
  mixins: [translation, permissionsList],
  components: {
    DatePicker,
    ListSelect,
    RecordTypePopup,
    Loader,
    Autocomplete,
    AutocompleteDevice,
    AutocompleteCertificate,
    ExcelInfoPopover,
    vSelectDist,
    vSelectPart,
    // vSelectCertificate,
    vSelectRecord,
    DuplicateConfirmation,
    GenericPopup,
    // FileUploadRegi,
    AddRecordFileUpload,
    DeletePopup,
    AddAddress,
    ConfirmationPopup,
    DefaultSearchWithTable,
    // DefaultULReview
  },
  filters: {
    date(value) {
      if (!value) {
        return '';
      }
      return moment(value).format('DD MMM YYYY');
    },
    fomateDate(value) {
      if (!value) {
        return '';
      }

      if (typeof value === 'object') {
        const tempdate = Date.parse(value);
        const temCheck = moment(tempdate).format('DD/MM/YYYY');
        if (temCheck === 'Invalid date' || temCheck === null) {
          return value;
        }
        return temCheck;
      }
      return value;
    }
  },
  watch: {
    nextBtn() {
      if (this.nextBtn === 'draft') this.saveRecord(true);
      else if (this.nextBtn === 'add') this.checkForNTMProduct(false);
    },
    disableNextStatus() {
      this.$emit('disableSaveBtn', this.disableNextStatus);
    },
    disableSaveAsDraft() {
      this.$emit('disableDraftBtn', this.disableSaveAsDraft);
    },
    isSaveDraft() {
      this.$emit('hideDraftBtn', this.isSaveDraft);
    },
    selectedRegistrationType(newVal) {
      if (newVal !== null) {
        if (newVal.id !== undefined) {
          this.disableProductClass = false;
        } else if (newVal !== '') {
          this.disableProductClass = false;
        } else {
          this.disableProductClass = true;
          this.selectedDeviceClass = '';
        }
      } else {
        this.disableProductClass = true;
        this.selectedDeviceClass = '';
      }
    },
    errorString() {
      if (this.errorString) {
        this.disableNextButton = true;
      } else {
        this.disableNextButton = false;
      }
    },
    inputStatus(newValue) {
      if (newValue === null) this.inputStatus = '';
    },
    selectedDeviceClass(newValue) {
      if (newValue === null) this.selectedDeviceClass = '';
    },
    selectedLocalRepresentative(newValue) {
      if (newValue === null) this.selectedLocalRepresentative = '';
    },

    selectedImportedProduct(newValue) {
      if (newValue === null) this.selectedImportedProduct = '';
    },
    selectedProduct() {
      this.displaySelectedProducts = this.selectedProduct;
    },
    excelErrorObj() {
      let set = true;
      this.excelErrorObj.forEach((error, i) => {
        if (this.excelErrorObj[i].errors.length > 0) {
          this.enableFinish = false;
          set = false;
        }
      });
      if (set !== false) {
        this.enableFinish = true;
      }
    },
    alertBeforeMonths() {
      if (this.alertBeforeMonths < 1 && !this.loaderStatus) {
        this.alertBeforeMonths = 1;
      }
    }
  },
  async mounted() {
    this.loaderStatus = true;
    this.subscriptions = await getSubscriptions(true);
    if (!this.$route.params.id) {
      this.submissionDate = new Date();
    }
    await this.initialAPICalls();
    // this.countryList = JSON.parse(localStorage.getItem('countryList'));
    this.countryList = await getAllCountries();
    if (this.$route.params.id && !this.invalidRecord) {
      this.registrationId = this.$route.params.id;
      // this.deleteBtn = true;
      this.getRegistrationDetailsById(this.$route.params.id);
    } else if (this.invalidRecord) {
      const record = JSON.parse(sessionStorage.getItem('selectedRecord'));
      if (record) {
        this.getRegistrationDetails(record);
      }
    }
    // this.resetAddRecordManualForm();
    $('#duplicateConfirmation').on('hidden.bs.modal', () => {
      $('body').addClass('modal-open');
    });
    await this.validateRecordsSize();
    if (this.recordAddonService) {
      if (
        this.recordAddonService.total_limit > this.recordAddonService.default_limit &&
          this.recordAddonService.is_active &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') < this.recordAddonService.valid_until &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') < this.recordAddonService.valid_from
      ) {
        this.enableAddFeature = false;
      }
    } else if (this.no_of_records < this.max_registrations) this.enableAddFeature = true;
    else this.enableAddFeature = false;
    this.showGenericePopup = true;
    // this.tableActiveTab = 1;
    // this.attachmentTypeList = [{ id: 1, tabName: 'Test Reports' }, { id: 2, tabName: 'Product Certificates' }, { id: 3, tabName: 'Barcodes' }, { id: 4, tabName: 'Maintenance Documents' }];
    // this.fileArrayObject = {
    //   // eslint-disable-next-line quote-props
    //   'Test Reports': [], 'Product Certificates': [], 'Barcodes': [], 'Maintenance Documents': []
    // };
    this.loaderStatus = false;
  },
  data() {
    return {
      validateselectedProductFamily: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            this.selectedProductFamily = '';
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira uma data de revisão válida'
                    : 'Please enter valid revision date',
              group: 'custom-notification'
            });
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      validateExpirationDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            this.expirationDate = '';
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira uma data de expiração válida'
                    : 'Please enter valid expiration date',
              group: 'custom-notification'
            });
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      validateNextDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (value && !date.isValid()) {
            this.next_maintenance_date = '';
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira a próxima data de manutenção válida'
                    : 'Please enter valid next maintenance date',
              group: 'custom-notification'
            });
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      validateIssueDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            this.approvalDate = '';
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira uma data de emissão válida'
                    : 'Please enter valid issue date',
              group: 'custom-notification'
            });
            return '';
          }
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      deletedIds: [],
      deleteBtn: true,
      render: 0,
      save_draft: false,
      regId: '',
      isSaveDraft: true,
      editRecord: (this.$route.params.id) ? true : false, // eslint-disable-line
      disableProductClass: true,
      selectedManufacturingAddress: '', // Manufacturing address
      multiPlantAddresses: [],
      permissions: [],
      attachmentTypeList: [{ id: 1, tabName: 'Test Reports' }, { id: 2, tabName: 'Product Certificates' }, { id: 3, tabName: 'Barcodes' }],
      fileArrayObject: {
        // eslint-disable-next-line quote-props
        'Test Reports': [], 'Product Certificates': [], 'Barcodes': [], 'Maintenance Documents': []
      },
      selectedDeletedTabs: [],
      tableActiveTab: 1,
      testReportsConfidentialArray: [],
      productCertificatesConfidentialArray: [],
      barCodesReportsConfidentialArray: [],
      confidential: [],
      highlyConfidential: [],
      userEnteredRegistrationType: '',
      role_id: '',
      tagAdded: false,
      testReportsArrowDirection: 1,
      productCertificatesArrowDirection: 1,
      barCodesArrowDirection: 1,
      maintenanceDocuementsArrowDirection: 1,
      medCompContactListByName: [],
      loggedInUser: '',
      deleteWarningInfo: {
        loaderStatus: false,
        title: '',
        file: '',
        type: '',
        fileIndex: '',
        customMessage: ''
      },
      headerTitle: '',
      attachmentType: '',
      uploadedFiles: [],
      showUpload: false,
      uploadFieldName: 'file',
      urlData: '',
      newAttachedFiles: '',
      isNotConaints: '',
      remains: [],
      companyName: '',
      errorString: '', // Display error - Product/Record name display
      disableNextButton: false,
      no_of_records: 0,
      max_registrations: 0,
      enableAddFeature: false,
      showGenericePopup: false,
      disableStatus: false,
      enableFinish: true,
      enableFinishAfterDelete: false,
      multiPartValue: [], // Barcode
      multiPartOptions: [],
      modelNames: [],
      modelArray: [],
      certificateValue: [],
      registrationTypeListForExcelTemplate: [],
      registrationTypeListForExcel: [],
      relatedCertificateListForExcel: [],
      relatedCertificateListForExcelTemplate: [],
      excelErrorObj: [],
      excelWarningObj: [],
      excelFinalWarningObj: [],
      loopFlag: false,
      countryListForExcel: [],
      toggleErrorRowList: [],
      matchColumns: '',
      translatedExcelColumnInfo: {},
      importExcelColumnInfoPortuguese: {
        productName: 'Nome do Produto;Nome do Produto para o qual você está inserindo os dados',
        registeringCountry: 'País de origem; Escolha o país de origem do produto',
        manufacturingAddress: 'Endereço de Fabricação;Escolha o endereço de fabricação do produto',
        manufacturer: 'Fabricante; A entidade que fabrica o produto',
        productCategory: 'Categoria do produto; Categoria do produto',
        registrationNumber: 'URL de certificação; O URL de certificação fornecido pela autoridade certificadora',
        submissionDate:
            'Data de Registro no Conformity Declaration Management; A data em que você cria o certificado no Conformity Declaration Management',
        registrationApprovalDate: 'Data de Emissão; A data em que você recebeu a certificação do órgão regulador',
        registrationExpirationDate: 'Data de Expiração; A data em que o registro expirará',
        alertBeforeMonths:
            'Data do Alerta; O número de meses antes da data de expiração em que o status do registro será definido como "Expirando em breve".',
        medCompContact: 'O nome do indivíduo em sua organização que é responsável ou preparou o registro',
        localRepresentative: 'Gerido por; Entidade que gere a certificação do produto',
        localDistributor: 'Nome da marca; O nome da marca do produto',
        localDistributorImport:
            'Os nomes das empresas responsáveis ​​pela distribuição do produto no país/marketplace cadastrado. Nota: este campo pode conter vários distribuidores. Para importar uma planilha contendo vários distribuidores em um único cadastro, separe os nomes dos distribuidores com vírgulas.',
        deviceUDI: 'Nome do modelo; O nome do modelo do produto',
        devicePartNumber: 'Código de barras; O código de barras associado ao produto',
        devicePartNumberImport:
            'Os números de peça associados aos dispositivos e acessórios que constituem o produto. Nota: este campo pode conter vários números de peça. Para importar uma planilha contendo vários números de peça em um único registro, separe os números de peça com vírgulas.',
        productType: '',
        productFamily: 'Data de manutenção; A data de manutenção em que a certificação precisará ser mantida',
        maintenanceDate: 'Próxima data de manutenção; A próxima data em que o registro deverá ser revisado',
        deviceClass:
            'Classe de produto; Selecione a classe de produto apropriada com base no tipo de produto e portaria/regulamento aplicável',
        comments: 'Comentários;Comentários de texto livre sobre o registro',
        configuration: 'Descrição; Um nome ou descrição que explica sobre o produto',
        deviceSoftwareVersion: 'Potência de entrada marcada; A potência marcada do produto',
        deviceHardwareVersion:
            'Tensão de entrada marcada; A tensão de entrada marcada na qual o produto deve ser usado',
        relatedCertificate: 'Registros Relacionados; Registros Semelhantes ou Relacionados',
        attachments: 'Ficheiros associados ao registo',
        registrationType: '',
        submissionNumber: 'Número de Certificação; Número de identificação emitido por agência reguladora',
        recordTypeName: 'Marca de certificação; Marca de certificação aprovada pelo produto de agências reguladoras',
        certificateNumber: 'Digite o número do certificado',
        issuedBy: 'Credenciado por;Nome da autoridade emissora',
        relatedProduct: 'Produto Relacionado;Produtos Semelhantes/Relacionados',
        standards: 'Normas; Normas do produto',
        ordinance: 'Portaria; Portaria do produto',
        importedProduct: 'Produto importado; Status da importação do produto',
        requester: 'Solicitante;Detalhe do solicitante do produto',
        importer: 'Importador; Importador Detalhes do produto',
        tradeRepresentative: 'Representante Comercial; Detalhes do representante comercial do produto',
        newPageStatus: 'Status;Status atual do produto.',
        test_report: 'Relatórios de teste; relatórios de teste detalhados do produto',
        product_certificate: 'Certificados de Produto; Certificados Aplicáveis ​​do Produto',
        barcodeFile: 'Arquivo do Código de Barras;Arquivo do Código de Barras associado ao produto',
        maintenance_documents: 'Documento de Manutenção;Documentos de manutenção associados ao produto'
      },
      importExcelColumnInfo: {
        productName: 'Product Name;Name of the Product for which you are entering the data',
        registeringCountry: 'Country of origin;Choose the country of origin of the product',
        manufacturingAddress: 'Manufacturing Address;Choose the manufacturing address of the product',
        manufacturer: 'Manufacturer;The entity which manufactures the product',
        productCategory: 'Product Category;Category of the product',
        registrationNumber: 'Certification URL;The certification url provided by the certifying authority',
        submissionDate:
            'Conformity Declaration Management Registration Date;The date when you create the certificate in the Conformity Declaration Management',
        registrationApprovalDate: 'Date of Issue;The date when you received the certification from the regulatory body',
        registrationExpirationDate: 'Date of Expiration;The date on which the registration will expire',
        alertBeforeMonths:
            'Alert Date;The number of months before the expiration date on which the registration’s status will be set to “Expiring Soon".',
        medCompContact:
            'The name of the individual at your organization who is responsible for or has prepared the registration',
        localRepresentative: 'Managed By;Entity managing the certification for the product',
        localDistributor: 'Brand name;The brand name of the product',
        localDistributorImport:
            'The names of companies responsible for distributing the product in the registered country / market. Note: this field can contain multiple distributors. To import a spreadsheet containing multiple distributors in a single registration, separate the distributor names with commas.',
        deviceUDI: 'Model Name;The model name of the product',
        devicePartNumber: 'Barcode;The barcode associated with the product',
        devicePartNumberImport:
            'The barcodes associated with the devices and accessories that constitute the product. Note: this field can contain multiple barcodes. To import a spreadsheet containing multiple barcodes in a single registration, separate the barcodes with commas.',
        productType: '',
        productFamily: 'Maintenance Date; The maintenance date which the certification will need to be maintained',
        maintenanceDate: 'Next Maintenance Date; The next date which the certification will need to be maintained',
        deviceClass:
            'Product Class;Select the appropriate Product class based on Product Type and applicable ordinance /regulation',
        comments: 'Comments;Free text comments about the registration',
        configuration: 'Description;A name or description which explains about the product',
        deviceSoftwareVersion: 'Marked Input Wattage;The marked wattage of the product',
        deviceHardwareVersion: 'Marked Input Voltage;The marked input voltage at which product is intended to be used',
        relatedCertificate: 'Related Records;Similar or related Records',
        attachments: 'Files associated with the registration',
        registrationType: '',
        submissionNumber: 'Certification Number;Identifcation number issued by regulatory agency',
        recordTypeName: 'Certification Mark;Certification marked approved by the product from regulatory agencies',
        certificateNumber: 'Enter Certificate number',
        issuedBy: 'Accredited By;Name of issuing authority',
        relatedProduct: 'Related Product;Similar/Related products',
        standards: 'Standards;Standards  of the product',
        ordinance: 'Ordinance;Ordinance of the product',
        importedProduct: 'Imported Product;Import status of the product',
        requester: 'Requester;Requester Detail for the product',
        importer: 'Importer;Importer Details of the product',
        tradeRepresentative: 'Trade Representative;Trade Representative Details of the product',
        newPageStatus: 'Status;Current Status of the product.',
        test_report: 'Test Reports;Detailed Testing reports of the product',
        product_certificate: 'Product Certificates;Applicable certificates of the Product',
        barcodeFile: 'Barcode File;Barcode file associated for the product',
        maintenance_documents: 'Maintenance Documents;Maintenance doucments associated for the product'
      },
      duplicateExcelColumnsList: [],
      loaderStatus: false,
      excelData: '',
      excelDataValue: [],

      selectedWorksheet: '',
      selectedWorksheetValue: {},
      excelColumns: [],

      selectedColumns: {
        productName: {},
        registeringCountry: {},
        manufacturer: {},
        registrationNumber: {},
        submissionDate: {},
        registrationApprovalDate: {},
        registrationExpirationDate: {},
        medCompContact: '',
        localRepresentative: {},
        localDistributor: {},
        configuration: {},
        deviceUDI: {},
        devicePartNumber: {},
        productType: {},
        productFamily: {},
        deviceClass: {},
        comments: {},
        registrationType: {},
        submissionNumber: {},
        relatedCertificate: {},
        authorised: 1,
        certificateTypeNameClass: false,
        certificateTypeName: '',
        recordTypeName: {},
        issuedBy: {},
        relatedProduct: ''
      },

      productNameColumn: '',

      selectedProduct: '', // product name
      productListByName: [],
      selectedCompany: '', // manufacturer
      othersSelectedCompany: '',
      companyListByName: [],
      selectedCountry: [], // Country of Origin
      countryList: [],
      registrationTypeList: [],
      selectedRegistrationType: [], // Product Category
      registrationNumber: '', // Certification URL
      isValidRegistrationNumber: false, // to check whether certification URL is valid or not to enable draft button
      selectedMedCompContact: '',
      selectedLocalDistributor: '', // Brand name

      selectedLocalRepresentative: '', // Managed By
      localRepresentativeListByName: [],
      managedByList: ['Self', 'UL', 'Others'],

      standards: '', // Standards
      ordinance: '', // Ordinance
      importedProduct: ['Yes', 'No'],
      requester: '', // Importer
      importer: '', // Requester
      tradeRepresentative: '', // Trade Representative
      newPageStatus: ['Active', 'Suspended', 'Cancelled'],
      medCompContact: '',
      test_report: '',
      product_certificate: '',
      barcodeFile: '',
      test_report_attachments: '',
      testReportAttachments: '',
      product_certificate_attachments: '',
      barcode_attachments: '',
      test_report_array: [],
      product_certificate_array: [],
      barcode_array: [],
      maintenanceDocumentsConfidentialArray: [],
      maintenance_documents: [],
      selectedImportedProduct: '', // Imported Product
      backendSelectedImportedProduct: '',
      inputStatus: '', // Status

      deviceUdi: [], // Model name

      devicePartNumber: '',
      selectedProductType: 'productType',
      productFamilyListByName: [],
      selectedProductFamily: '', // Revision Date
      next_maintenance_date: '',
      suggestedMaintenenceDate: '',
      maintenance_cycle_days: 365,
      deviceClassList: [],
      deviceList: [],
      deviceClassId: {},
      selectedDeviceClass: '', // Product class
      relatedCertificateList: [],
      certificateDropDownLabel: '',

      submissionDate: '', // Registration Date
      approvalDate: '', // Date of Issue
      expirationDate: '', // Date of Expiration
      alertBeforeMonths: 12, // Alert Date
      comments: '', // Comments
      configuration: '', // Description

      selectedSheetRecords: '',

      tableData: '',
      excelTableData: [],
      headerList: [],

      stepCount: 0,
      preferredRegistrationWay: 'manual',

      shortcuts: [
        {
          text: 'Today',
          start: new Date(),
          end: new Date()
        }
      ],

      errors: [],

      excelExportList: [],

      showFooterNext: true,
      showFooterBack: true,
      showFooterFinish: false,
      totalStepCount: '',
      errorRowIndexList: [],
      errorRowIndexListCopy: [],
      warningRowIndexList: [],
      warningRowIndexListCopy: [],
      errorRowData: '',
      errorLogs: '',
      manualErrorData: [],

      topPosition: '',
      leftPosition: '',
      displayStatus: 'none',
      registrationNumberExistStatus: false,
      singleSheet: false,
      excelRowsWithErrors: [],
      excelRowsWithoutErrors: [],
      submissionNumber: '', // Certification Number
      certificateCountryListUnique: '',
      allCerticateType: [],
      certificateTypeNameClass: false,
      authorised: 1,
      authorisedSeparator: true,
      allCerticateTypeNotAuthorized: [],
      certificateTypeList: [],
      certificateTypeName: '',
      recordTypeName: '-',
      disableExpirydate: false,
      recordNameList: '',
      showRelatedProduct: false,
      relatedProduct: '',
      displaySelectedProducts: '',
      displaySelectedProductsNext: '',
      certificateIssuedByList: [],
      certificateIssuerList: [],
      issuedBy: '', // Accredited by
      multipleProductNames: [],
      selectedrelatedProductList: [],
      multipleProductNameList: [],
      regulationCheck: false,
      validateFlag: false,
      validateFlagForSpreadsheet: false,
      dup_FlagForManual: false,
      duplicateChkFlag: false,
      IsManual: 'Manual',
      // delete_Flag:false
      warningCountArray: [],
      acceptedExtensions: ['pdf', 'doc', 'docx', 'jpg', 'tif', 'gif', 'png', 'xlsx', 'xls', 'ppt', 'pptx'],
      invalidFilesUploaded: [],
      errorExtensions: '',
      selected_product_device_class: '',
      fileUploadStatus: false,
      disableAlertDate: false,
      account_id: '',
      uploadCasesError: '',
      recordAddonService: {},
      teamAddonService: {},
      upgradeService: {},
      genericPopupId: 'genericPopupRevision',
      currentSlider: 1,
      slidesInfo: [{ title: 'Registration Details' }, { title: 'Attachments' }],
      certificateCountryList: [],
      countryCertificateType: [],
      certificateCountryManual: [],
      registrationId: '',
      selectedRegistration: {},
      attachments: '',
      add: false,
      roleId: '',
      highlyConfidentialPermission: '',
      confirmMessage: '',
      selectedLanguage: '',
      issueStatus: '',
      issueType: '',
      revision: '',
      newToMarket: false,
      invalidRecord: false,
      subscriptions: [],
      todo_checklist_complete: false,
      promptMsg: '',
      isNewToMarket: '',
      addressData: '',
      finalModelList: '',
      all_attachments: '',
      reviewCertificate: false,
      confirmationText: '',
      deleteRecords: ''
    };
  },
  computed: {
    disableNextDate() {
      let result = !this.reviewCertificate;
      if (this.editRecord && !this.reviewCertificate && (this.selectedRegistration.next_maintenance_date === null || this.selectedRegistration.next_maintenance_date === '' || this.selectedRegistration.next_maintenance_date === 'N/A')) result = false;
      return this.$route.params.id ? result : false;
    },
    disableSaveAsDraft() { // this.submissionDate, this.alertBeforeMonths, this.registrationNumber( use this.isValidRegistrationNumber) - not included, have to check
      if (this.selectedCompany || this.selectedLocalDistributor ||
        (this.selectedCountry && Object.keys(this.selectedCountry).length > 0) ||
        this.selectedManufacturingAddress || this.multiPartValue.length > 0 ||
        this.selectedProduct || this.deviceUdi.length > 0 ||
        (this.selectedRegistrationType && Object.keys(this.selectedRegistrationType).length > 0) ||
        this.selectedDeviceClass || this.configuration || this.submissionNumber || this.isValidRegistrationNumber ||
        this.selectedLocalRepresentative || this.issuedBy || this.approvalDate || this.selectedProductFamily || this.next_maintenance_date ||
        this.expirationDate || this.standards || this.ordinance || this.selectedImportedProduct || this.importer ||
        this.requester || this.tradeRepresentative || this.inputStatus || this.comments) {
        return false;
      }
      return true;
    },
    showHideDraftBtn() {
      return this.isSaveDraft;
    },
    disableCheckBox() {
      const response = (this.editRecord && (this.selectedRegistration.expiration_date !== null && this.selectedRegistration.expiration_date !== '') && !this.isSaveDraft && !this.invalidRecord);
      return this.invalidRecord ? true : response;
    },
    disableNextStatus() {
      let selectedRegistrationTypeId = '';
      let selectedRegistrationTypeName = '';
      if (this.tagAdded) {
        selectedRegistrationTypeId = this.selectedRegistrationType[0].id;
        selectedRegistrationTypeName = this.selectedRegistrationType[0].name;
      }
      if (!this.tagAdded && this.selectedRegistrationType) {
        selectedRegistrationTypeId = this.selectedRegistrationType.id;
        selectedRegistrationTypeName = this.selectedRegistrationType.name;
      }
      if (
        this.selectedProduct &&
          this.selectedProduct.length !== 0 &&
          this.selectedCountry.country_name &&
          (selectedRegistrationTypeId || selectedRegistrationTypeName) &&
          this.selectedCompany !== '' &&
          this.deviceUdi?.length !== 0 &&
          this.loaderStatus !== true &&
          this.productType !== '' &&
          this.selectedDeviceClass !== '' &&
          (this.newToMarket || this.$route.query.type === true || this.$route.query.type === 'true' || (!this.newToMarket && (this.$route.query.type === false || this.$route.query.type === 'false') && this.approvalDate && (this.expirationDate) && this.next_maintenance_date && this.submissionNumber && this.selectedLocalRepresentative !== '')) &&
          this.selectedImportedProduct !== '' &&
          this.inputStatus !== '' &&
          this.selectedManufacturingAddress
      ) {
        this.$emit('disableSaveBtn', false);
        return false;
      }
      this.$emit('disableSaveBtn', true);
      return true;
    },
    disableUpload() {
      if (!this.remains.length && this.uploadedFiles.length) {
        return false;
      }
      return true;
    },
    duplicateExcelColumnsStatus() {
      const valueArr = Object.values(this.selectedColumns).map((item) => item.value);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.duplicateExcelColumnsList = valueArr.filter(
        (item, idx) => item !== undefined && valueArr.indexOf(item) !== idx
        ); // eslint-disable-line
      return this.duplicateExcelColumnsList.length > 0;
    }
  },
  methods: {
    showConfirmationPopup(id, index) {
      this.deletedIds.push(id);
      this.headerTitle = this.$i18n.locale === 'Portuguese' ? 'Excluir arquivo' : 'Delete File(s)';
      this.deleteWarningInfo.title = this.$i18n.locale === 'Portuguese' ? 'Você está prestes a deletar o arquivo' : 'You are about to delete the file';
      this.fileIndex = index;
      this.deleteWarningInfo.type = 'attachment';
      this.deleteWarningInfo.customMessage =
        this.$i18n.locale === 'Portuguese'
          ? 'Uma vez excluído, você não poderá recuperá-lo.'
          : 'Once deleted, you will not be able to recover it.';
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    updateRecordsId() {
      if (this.dup_FlagForManual) {
        this.saveDuplicateRecord();
        return;
      }
      if (this.deleteWarningInfo.type === 'attachment') {
        this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName] = this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName].filter((fileItem, index) => index !== this.fileIndex);
        $('#modal_delete').modal('hide');
      }
    },
    resetData() {
      if (this.deletedIds.length) {
        this.deletedIds.pop();
      } else this.deletedIds = '';
    },
    tabChangedEmit(e) {
      this.tableActiveTab = e;
    },
    showDeletePopup(e) {
      this.selectedDeletedTabs = e;
      this.deleteRecords = this.$i18n.locale === 'Portuguese' ? 'Excluir registros' : 'Delete Records';
      this.confirmationText = this.$i18n.locale === 'Portuguese' ? 'Você está prestes a excluir os registros. Uma vez excluído, você não poderá recuperar as informações.' : 'Your are about to delete the records. You will not be able to recover the information.';
      $('#deleteRecord').modal('show');
    },
    deleteFile() {
      $('#deleteRecord').modal('hide');
      if (this.selectedDeletedTabs.length > 0) {
        // eslint-disable-next-line array-callback-return
        let res = this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName].filter((fileItem) => !this.selectedDeletedTabs.includes(fileItem.attachmentId));
        this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName] = res;
        res = [];
        this.selectedDeletedTabs = [];
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'English' ? 'The selected documents are deleted successfully.' : 'Os documentos selecionados foram excluídos com sucesso para.',
          group: 'custom-notification',
        });
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Falha ao excluir documentos.' : 'Failed to delete documents.',
          group: 'custom-notification',
        });
      }
    },
    issueDateUpdate() {
      let tempDate2 = moment(this.approvalDate)
        .utc()
        .add(this.maintenance_cycle_days, 'days');
      while (new Date(tempDate2) < new Date()) {
        tempDate2 = moment(tempDate2)
          .utc()
          .add(this.maintenance_cycle_days, 'days');
      }
      // eslint-disable-next-line no-underscore-dangle
      this.next_maintenance_date = moment(tempDate2)._d;
    },
    async downloadFile(file) {
      await downloadFile(this.registrationId, file);
    },
    async getFiles() {
      this.all_attachments = await getAttachments(this.registrationId);
      this.filterAttachments(this.all_attachments);
    },
    async isValidDate() {
      const time1 = moment(this.next_maintenance_date).format('YYYY-MM-DD');
      const today = new Date();
      const time2 = moment(today).format('YYYY-MM-DD');
      if (time1 < time2) {
        this.next_maintenance_date = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
                  this.$i18n.locale === 'Portuguese'
                    ? 'Insira a data da próxima manutenção maior ou igual à data de hoje'
                    : 'Please enter next maintenance date greater than or equal to today\'s date',
          group: 'custom-notification'
        });
      }
    },
    async updatePlantLocation() {
      await this.getPlantLocations();
      this.selectedManufacturingAddress = this.multiPlantAddresses[this.multiPlantAddresses.length - 2].plantLocationId;
      // eslint-disable-next-line no-plusplus
      this.render++;
    },
    updateManufacturingAddress() {
      if (this.addressData) this.selectedManufacturingAddress = this.addressData.plantLocationId;
      else this.selectedManufacturingAddress = null;
      // eslint-disable-next-line no-plusplus
      this.render++;
    },
    addAddress(event) {
      if (event === 0) {
        // EventBus.$emit('addAddress');
        $('#addAddress').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    async getPlantLocations() {
      const result = await getMultiplantAddress();
      let multiPlantLocations = [];
      this.multiPlantAddresses = [];
      if (result.status_code === 200) {
        multiPlantLocations = result.data;
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: result.data,
          group: 'custom-notification'
        });
      }

      if (multiPlantLocations.length) {
        this.multiPlantAddresses = multiPlantLocations.map((item) => ({
          addressDetails: `${item.streetAddress} ${item.city} ${item.state} ${item.country} ${item.postCode}`,
          plantLocationId: item.plantLocationId
        }));
      }
      const addressLabel = this.$i18n.locale === 'Portuguese' ? '+ Adicionar endereço' : '+ Add Address';
      this.multiPlantAddresses.push({ addressDetails: addressLabel, plantLocationId: 0 });
    },
    // updateAttachments(attachments, type) { // this
    //   if (type === 'test_report_attachments') {
    //     attachments.split(';').forEach((file) => {
    //       if (file) {
    //         const fileInfo = this.test_report_array.find((item) => item.attachmentLink === file);
    //         if (!fileInfo) {
    //           this.test_report_array.unshift({ attachmentLink: file, highlyConfidential: false });
    //           this.testReportsConfidentialArray.unshift(false);
    //         }
    //       }
    //     });
    //     this.test_report_attachments = this.test_report_array;
    //   } else if (type === 'product_certificate_attachments') {
    //     attachments.split(';').forEach((file) => {
    //       if (file) {
    //         const fileInfo = this.product_certificate_array.find((item) => item.attachmentLink === file);
    //         if (!fileInfo) {
    //           this.product_certificate_array.unshift({ attachmentLink: file, highlyConfidential: false });
    //           this.productCertificatesConfidentialArray.unshift(false);
    //         }
    //       }
    //     });
    //     this.product_certificate_attachments = this.product_certificate_array;
    //   } else if (type === 'barcode_attachments') {
    //     attachments.split(';').forEach((file) => {
    //       if (file) {
    //         const fileInfo = this.barcode_array.find((item) => item.attachmentLink === file);
    //         if (!fileInfo) {
    //           this.barcode_array.unshift({ attachmentLink: file, highlyConfidential: false });
    //           this.barCodesReportsConfidentialArray.unshift(false);
    //         }
    //       }
    //     });
    //     this.barcode_attachments = this.barcode_array;
    //   }
    // },
    isValidUrl(string) {
      try {
        const res = string.match(
          /(http:\/\/|https:\/\/)(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-\/]))?/ // eslint-disable-line no-useless-escape
        );
        return res !== null;
      } catch (err) {
        return false;
      }
    },
    checkValidUrl() {
      if (!this.registrationNumber) return false;
      let res = '';
      if (this.registrationNumber) {
        res = this.isValidUrl(this.registrationNumber);
      }
      if (!res) {
        this.registrationNumber = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
              this.$i18n.locale === 'Portuguese'
                ? 'Insira um URL de certificação válido'
                : 'Enter valid Certification URL',
          group: 'custom-notification'
        });
        this.isValidRegistrationNumber = false;
        return false;
      }
      this.isValidRegistrationNumber = true;
      return true;
    },
    async getPermissions() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.highlyConfidentialPermission = this.permissions.indexOf('HIGHLY_CONFIDENTIAL') > -1;
    },
    sortBy(direction, data) {
      if (direction === 1) data.sort((a, b) => (a > b ? -1 : 1));
      else {
        data.sort((a, b) => {
          const fileOne = a.toUpperCase(); // ignore upper and lowercase
          const fileTwo = b.toUpperCase(); // ignore upper and lowercase
          if (fileOne < fileTwo) {
            return -1;
          }
          if (fileOne > fileTwo) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      }
    },
    openAttachment(attachments) { // check
      this.attachments = attachments;
      $('#addRecordFileUpload').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async deleteAttachment(file, type) { // check
      if (this.dup_FlagForManual) {
        this.saveDuplicateRecord();
        return;
      }
      if (!type) {
        this.updateConfidentiality();
        return;
      }
      const attachments = {
        revision: this.revision,
        attachmentId: file.attachmentId,
        registrationId: Number(this.registrationId)
      };
      this.loaderStatus = true;
      const fileDeleteRes = await deleteAttachments(attachments);
      if (fileDeleteRes.status_code === 200) {
        $('#modal_delete').modal('hide');
        this.revision = fileDeleteRes.revision;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text:
              this.$i18n.locale === 'Portuguese'
                ? 'Arquivo(s) excluído(s) com sucesso!'
                : 'File(s) deleted successfully!',
          group: 'custom-notification'
        });
        await this.getFiles();
        this.loaderStatus = false;
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'A exclusão do(s) Arquivo(s) falhou!' : 'File(s) deletion failed!',
          group: 'custom-notification'
        });
      }
      // this.deleteWarningInfo.file = '';
      // this.deleteWarningInfo.type = '';
      // this.deleteWarningInfo.fileIndex = '';
    },
    async getRegistrationDetailsById(id) { // check
      this.loaderStatus = true;
      const response = await getRegistrationDetailsById(id);
      if (response.errors) {
        this.loaderStatus = false;
        this.manualErrorData = response.errors;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'A busca do produto falhou!' : 'Fetching product failed!',
          group: 'custom-notification'
        });
        this.certificateValue = [];
        this.loaderStatus = false;
      } else {
        this.loaderStatus = false;
        this.selectedRegistration = response;
        this.isSaveDraft = response.save_draft;
        this.$emit('hideDraftBtn', this.isSaveDraft);
        if (this.isSaveDraft) {
          this.submissionDate = new Date();
        }
        this.isNewToMarket = this.selectedRegistration.isNewToMarket;
        this.todo_checklist_complete = this.selectedRegistration.todo_checklist_complete ? this.selectedRegistration.todo_checklist_complete : this.todo_checklist_complete;
        this.revision = this.selectedRegistration.revision;
        this.selectedCompany = this.selectedRegistration.registrationCompany;
        if (this.selectedRegistration.country_name) {
          this.selectedCountry = {
            country_name: this.selectedRegistration.country_name,
            country_id: this.selectedRegistration.country_id,
            country_code: this.selectedRegistration.country_code
          };
        } else {
          this.selectedCountry = [];
        }
        this.selectedProduct = this.selectedRegistration.product_name;
        if (this.selectedRegistration.registrationType !== null) {
          this.selectedRegistrationType = { name: this.selectedRegistration.registrationType };
        } else {
          this.selectedRegistrationType = [];
        }
        this.deviceList = [];
        this.deviceClassList = [];
        if (this.selectedRegistration.registrationType !== null) {
          this.deviceList = await getProductClass(
            this.registrationTypeList.filter((item) => item.name === this.selectedRegistrationType.name)[0].id
          );
        }
        this.deviceList.forEach((data) => {
          this.deviceClassList.push(data.name);
        });
        this.selectedDeviceClass = this.selectedRegistration.product_class;
        this.medCompContact = this.selectedRegistration.medcomp_contact_name;
        this.configuration = this.selectedRegistration.configuration;
        this.submissionNumber = this.selectedRegistration.submission_number;
        this.registrationNumber = this.selectedRegistration.registration_number;
        this.selectedLocalRepresentative = this.selectedRegistration.local_representative;
        this.issuedBy = this.selectedRegistration.issued_by;
        if (
          this.selectedRegistration.submission_date &&
            this.selectedRegistration.submission_date !== 'N/A' &&
            this.selectedRegistration.submission_date !== 'Invalid date'
            && !this.isSaveDraft
        ) {
          this.submissionDate = new Date(this.selectedRegistration.submission_date);
        }
        if (
          this.selectedRegistration.approval_date &&
            this.selectedRegistration.approval_date !== 'N/A' &&
            this.selectedRegistration.approval_date !== 'Invalid date'
        ) {
          this.approvalDate = new Date(this.selectedRegistration.approval_date);
        }
        if (
          this.selectedRegistration.product_family &&
            this.selectedRegistration.product_family !== 'N/A' &&
            this.selectedRegistration.product_family !== 'Invalid date'
        ) {
          // eslint-disable-next-line no-underscore-dangle
          this.selectedProductFamily = moment(this.selectedRegistration.product_family)._d;
        }
        if (
          this.selectedRegistration.next_maintenance_date &&
            this.selectedRegistration.next_maintenance_date !== 'N/A' &&
            this.selectedRegistration.next_maintenance_date !== 'Invalid date'
        ) {
          if (this.reviewCertificate) {
            const res = await getNextMaintenanceDate(this.registrationId);
            // eslint-disable-next-line no-underscore-dangle
            this.next_maintenance_date = moment(res.next_maintenance_date)._d;
            // eslint-disable-next-line no-underscore-dangle
            this.suggestedMaintenenceDate = moment(res.next_maintenance_date)._d;
          }
          // eslint-disable-next-line no-underscore-dangle
          this.next_maintenance_date = this.reviewCertificate ? this.next_maintenance_date : moment(this.selectedRegistration.next_maintenance_date)._d;
        }
        if (
          this.selectedRegistration.expiration_date &&
            this.selectedRegistration.expiration_date !== 'N/A' &&
            this.selectedRegistration.expiration_date !== 'Invalid date'
        ) {
          this.expirationDate = new Date(this.selectedRegistration.expiration_date);
        }
        this.alertBeforeMonths = this.selectedRegistration.alertBeforeMonths;
        this.standards = this.selectedRegistration.standards;
        this.ordinance = this.selectedRegistration.ordinance;
        let importProductLabel = '';
        if (this.selectedRegistration.imported_product === null) {
          importProductLabel = '';
        } else if (this.selectedRegistration.imported_product) {
          importProductLabel = this.$i18n.locale === 'Portuguese' ? 'Sim' : 'Yes';
        } else {
          importProductLabel = this.$i18n.locale === 'Portuguese' ? 'Não' : 'No';
        }
        this.selectedImportedProduct = importProductLabel;
        this.backendSelectedImportedProduct = this.selectedRegistration.imported_product;
        this.importer = this.selectedRegistration.importer;
        this.requester = this.selectedRegistration.requester;
        this.tradeRepresentative = this.selectedRegistration.trade_representative;
        this.inputStatus = this.selectedRegistration.inputStatus;
        this.comments = this.selectedRegistration.comments;
        this.multiPartValue = [];
        this.certificateValue = [];
        this.issueStatus = this.selectedRegistration.issueStatus;
        this.issueType = this.selectedRegistration.issueType;
        this.addressData = this.multiPlantAddresses.find(
          (item) => item.plantLocationId === this.selectedRegistration.plantLocationId
        );
        if (this.selectedRegistration.plantLocationId !== null && this.addressData && this.addressData.plantLocationId) {
          this.selectedManufacturingAddress = this.addressData.plantLocationId;
        }
        // this.RenewalProgress = this.data.renewal_in_progress;
        // this.ModificationProgress = this.data.modification_in_progress;
        this.selectedLocalDistributor = this.selectedRegistration.distributor_name;
        if (this.selectedRegistration.barcode === '' || this.selectedRegistration.barcode === null) {
          this.multiPartValue = [];
        } else {
          this.selectedRegistration.barcode.split(',').forEach((partLoc) => {
            this.multiPartValue.push(partLoc);
          });
        }
        if (this.selectedRegistration.udi === '' || this.selectedRegistration.udi === null) {
          this.deviceUdi = [];
        } else if (this.selectedRegistration.udi) {
          this.selectedRegistration.udi.split(',').forEach((partLoc) => {
            this.deviceUdi.push(partLoc);
          });
        }
        // await this.getFiles();
        Object.keys(this.fileArrayObject).forEach((category) => {
          if (category === 'Test Reports') this.fileArrayObject[category] = response.test_report_attachments;
          if (category === 'Product Certificates') this.fileArrayObject[category] = response.product_certificate_attachments;
          else if (category === 'Barcodes') this.fileArrayObject[category] = response.barcode_attachments;
          else if (category === 'Maintenance Documents') this.fileArrayObject[category] = response.maintenance_attachments;
        });

        this.newToMarket = this.selectedRegistration.isNewToMarket;
      }
    },
    async getRegistrationDetails(record) {
      this.loaderStatus = true;
      this.selectedRegistration = record;
      this.isSaveDraft = record.save_draft;
      if (this.isSaveDraft) {
        this.submissionDate = new Date();
      }
      this.isNewToMarket = this.selectedRegistration.isNewToMarket;
      this.todo_checklist_complete = this.selectedRegistration.todo_checklist_complete ? this.selectedRegistration.todo_checklist_complete : this.todo_checklist_complete;
      this.revision = this.selectedRegistration.revision;
      this.selectedCompany = this.selectedRegistration.Manufacturer;
      if (this.selectedRegistration.countryId) {
        this.selectedCountry = {
          country_name: this.selectedRegistration.Country,
          country_id: this.selectedRegistration.countryId,
          country_code: this.selectedRegistration['Country Code']
        };
      } else {
        this.selectedCountry = [];
      }
      this.selectedProduct = this.selectedRegistration.Product;
      if (this.selectedRegistration.registrationType !== null) {
        this.selectedRegistrationType = this.registrationTypeList.find((item) => item.id === this.selectedRegistration.registrationType);
      } else {
        this.selectedRegistrationType = [];
      }
      this.deviceList = [];
      this.deviceClassList = [];
      if (this.selectedRegistration.registrationType !== null && this.selectedRegistrationType && this.registrationTypeList && this.registrationTypeList.length) {
        this.deviceList = await getProductClass(
          this.registrationTypeList.filter((item) => item.name === this.selectedRegistrationType.name)[0].id
        );
      }
      this.deviceList.forEach((data) => {
        if (data.id === this.selectedRegistration.product_class_id) {
          this.selectedDeviceClass = data.name;
        }
        this.deviceClassList.push(data.name);
      });
      this.medCompContact = this.selectedRegistration.medCompContact;
      this.configuration = this.selectedRegistration.Configuration;
      this.submissionNumber = this.selectedRegistration.submissionNumber;
      this.registrationNumber = this.selectedRegistration.certificationURL;
      this.selectedLocalRepresentative = this.selectedRegistration.managedBy;
      this.issuedBy = this.certificateIssuerList.find((certi) => certi.id === this.selectedRegistration['Issued by']) ? this.certificateIssuerList.find((certi) => certi.id === this.selectedRegistration['Issued by']).certificate_issued_by : '';
      if (
        this.selectedRegistration.rawSubmissionDate &&
          this.selectedRegistration.rawSubmissionDate !== 'N/A' &&
          this.selectedRegistration.rawSubmissionDate !== 'Invalid date'
          && !this.isSaveDraft
      ) {
        this.submissionDate = new Date(this.selectedRegistration.rawSubmissionDate);
      }
      if (
        this.selectedRegistration.rawApprovalDate &&
          this.selectedRegistration.rawApprovalDate !== 'N/A' &&
          this.selectedRegistration.rawApprovalDate !== 'Invalid date'
      ) {
        this.approvalDate = new Date(this.selectedRegistration.rawApprovalDate);
      }
      if (
        this.selectedRegistration.rawRevisionDate &&
          this.selectedRegistration.rawRevisionDate !== 'N/A' &&
          this.selectedRegistration.rawRevisionDate !== 'Invalid date'
      ) {
        this.selectedProductFamily = moment(this.selectedRegistration.rawRevisionDate)
          .format('YYYY-MM-DD');
      }
      if (
        this.selectedRegistration.rawExpirationDate &&
          this.selectedRegistration.rawExpirationDate !== 'N/A' &&
          this.selectedRegistration.rawExpirationDate !== 'Invalid date'
      ) {
        this.expirationDate = new Date(this.selectedRegistration.rawExpirationDate);
      }
      if (
        this.selectedRegistration.nextMaintenanceDate &&
          this.selectedRegistration.nextMaintenanceDate !== 'N/A' &&
          this.selectedRegistration.nextMaintenanceDate !== 'Invalid date'
      ) {
        this.next_maintenance_date = new Date(this.selectedRegistration.nextMaintenanceDate);
      }
      this.alertBeforeMonths = this.selectedRegistration.alertBeforeMonths;
      this.standards = this.selectedRegistration.standards;
      this.ordinance = this.selectedRegistration.ordinance;
      let importProductLabel = '';
      if (this.selectedRegistration.imported_product === null) {
        importProductLabel = '';
      } else if (this.selectedRegistration.imported_product) {
        importProductLabel = this.$i18n.locale === 'Portuguese' ? 'Sim' : 'Yes';
      } else {
        importProductLabel = this.$i18n.locale === 'Portuguese' ? 'Não' : 'No';
      }
      this.selectedImportedProduct = importProductLabel;
      this.backendSelectedImportedProduct = this.selectedRegistration.imported_product;
      this.importer = this.selectedRegistration.importer;
      this.requester = this.selectedRegistration.requester;
      this.tradeRepresentative = this.selectedRegistration.trade_representative;
      this.inputStatus = this.selectedRegistration.Status;
      this.comments = this.selectedRegistration.Comments;
      this.multiPartValue = [];
      this.certificateValue = [];
      this.issueStatus = this.selectedRegistration.issueStatus;
      this.issueType = this.selectedRegistration.issueType;
      this.addressData = this.multiPlantAddresses.find(
        (item) => item.plantLocationId === this.selectedRegistration.plantLocationId
      );
      if (this.selectedRegistration.plantLocationId !== null && this.addressData && this.addressData.plantLocationId) {
        this.selectedManufacturingAddress = this.addressData?.plantLocationId;
      }
      // this.RenewalProgress = this.data.renewal_in_progress;
      // this.ModificationProgress = this.data.modification_in_progress;
      this.selectedLocalDistributor = this.selectedRegistration['Local distributor'];
      if (this.selectedRegistration.Barcode === '' || this.selectedRegistration.Barcode === null) {
        this.multiPartValue = [];
      } else {
        this.selectedRegistration.Barcode.split(',').forEach((partLoc) => {
          this.multiPartValue.push(partLoc);
        });
      }
      if (this.selectedRegistration['Device UDI'] === '' || this.selectedRegistration['Device UDI'] === null) {
        this.deviceUdi = [];
      } else if (this.selectedRegistration['Device UDI']) {
        this.selectedRegistration['Device UDI'].split(',').forEach((partLoc) => {
          this.deviceUdi.push(partLoc);
        });
      }
      this.newToMarket = this.selectedRegistration.isNewToMarket;
      this.loaderStatus = false;
    },
    filterAttachments(attachments) {
      // eslint-disable-next-line no-multi-assign
      this.test_report_array = [];
      this.product_certificate_array = [];
      this.barcode_array = [];
      this.maintenance_documents = [];
      if (attachments) {
        attachments.forEach((item) => {
          if (item.attachment_type_id === 1 && !(item.highlyConfidential && !this.highlyConfidentialPermission)) {
            this.testReportsConfidentialArray.push(item.highlyConfidential);
            this.test_report_array.push(item);
          } else if (item.attachment_type_id === 2 && !(item.highlyConfidential && !this.highlyConfidentialPermission)) {
            this.productCertificatesConfidentialArray.push(item.highlyConfidential);
            this.product_certificate_array.push(item);
          } else if (item.attachment_type_id === 3 && !(item.highlyConfidential && !this.highlyConfidentialPermission)) {
            this.barCodesReportsConfidentialArray.push(item.highlyConfidential);
            this.barcode_array.push(item);
          } else if (item.attachment_type_id === 4 && !(item.highlyConfidential && !this.highlyConfidentialPermission)) {
            this.maintenanceDocumentsConfidentialArray.push(item.highlyConfidential);
            this.maintenance_documents.push(item);
          }
        });
      }
    },
    disableDateBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    disableDateTillToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date <= today;
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    isDateDisabled(date) {
      const validateDate = new Date(date);
      if (validateDate.toString() === 'Invalid Date') {
        return true;
      }
      return false;
    },
    dateValidationEdit(value) {
      if (value === undefined || value === 'dne' || value === 'DNE') {
        return true;
      }
      if (value.toString().includes('/') || value.toString().includes('-') || value.toString().includes('.')) {
        const type1 = value.indexOf('/');
        const type2 = value.indexOf('-');
        const type3 = value.indexOf('.');
        if (type1 !== -1 || type2 !== -1 || type3 !== -1) {
          let parts;
          if (type1 !== -1) {
            parts = value.split('/');
          } else if (type2 !== -1) {
            parts = value.split('-');
          } else {
            parts = value.split('.');
          }
          parts[0] = parseInt(parts[0], 10); // Year
          parts[1] = parseInt(parts[1], 10); // Month
          parts[2] = parseInt(parts[2], 10); // Date
          const mydate = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
          if (parts[1] > 12 || mydate.toString() === 'Invalid Date') {
            return false;
          }
          return true;
        }
      }
      if (value) {
        const d = new Date(value);
        return d.toString() !== 'Invalid Date'; // false
      }
      return false;
    },
    upgradeRecords() {
      EventBus.$emit('upgradeRecords', {
        recordAddonService: this.recordAddonService,
        teamAddonService: this.teamAddonService
      });
    },
    async validateRecordsSize() {
      this.loaderStatus = true;
      const addonAccountDetails = await getAddonDetails(this.account_id);
      this.recordAddonService = addonAccountDetails.find((each) => each.units === 'RECORDS');
      this.teamAddonService = addonAccountDetails.find((each) => each.units === 'USERS');
      if (!this.recordAddonService) {
        const addon = [];
        addon.push({
          account: false,
          active: true,
          id: 2,
          price: 0,
          valid_from: moment.utc(),
          valid_until: moment
            .utc()
            .add('years', 1)
            .subtract(1, 'days'),
          volume: 2097152
        });
        addon.push({
          account: false,
          active: true,
          id: 3,
          price: 0,
          valid_from: moment.utc(),
          valid_until: moment
            .utc()
            .add('years', 1)
            .subtract(1, 'days'),
          volume: 250
        });
      }
      this.loaderStatus = false;
      if (this.recordAddonService) {
        if (
          this.recordAddonService.total_limit >= this.recordAddonService.default_limit &&
            this.recordAddonService.is_active &&
            moment()
              .utc()
              .format('YYYY-MM-DD HH:mm:ss') < this.recordAddonService.valid_until &&
            moment()
              .utc()
              .format('YYYY-MM-DD HH:mm:ss') >= this.recordAddonService.valid_from
        ) {
          this.max_registrations = this.recordAddonService.total_limit;
        } else if (
          this.recordAddonService.total_limit >= this.recordAddonService.default_limit &&
            this.recordAddonService.is_active &&
            moment()
              .utc()
              .format('YYYY-MM-DD HH:mm:ss') > this.recordAddonService.valid_until &&
            moment()
              .utc()
              .format('YYYY-MM-DD HH:mm:ss') >= this.recordAddonService.valid_from
        ) {
          this.max_registrations = this.recordAddonService.default_limit;
        }
        this.no_of_records = this.recordAddonService.current_utilization;
      }
    },
    getStatus(status) {
      this.fileUploadStatus = status;
    },
    // Archana 2009 added below method as part of certificate option updates
    AddOtherOption(item) {
      // if (fieldName === 'certification mark') {
      //   this.getAlertDateCount();
      //   return;
      // }
      this.certificateTypeNameClass = false;
      const flag = false;
      if (!flag && item !== '') {
        this.certificateTypeNameClass = true;
        // Add Payload Value for Authorized Certificate types
        this.authorised = 0;
      } else {
        this.certificateTypeNameClass = false;
        this.authorised = 1;
      }
      // Merging Tabs Changes
      if (item === 'Product Registration') {
        this.showRelatedProduct = false;
      } else {
        this.showRelatedProduct = true;
      }
      this.selected_product_device_class = item;
    },
    chkDuplicate(errorArrLen, warningArrLen) {
      if (errorArrLen === 0 && warningArrLen > 0) {
        return true;
      }
      return false;
    },
    isDate(value) {
      if (value) {
        const d = new Date(value);
        return d.toString() !== 'Invalid Date';
      }
      return false;
    },
    dateValidation(value) {
      if (value === undefined) {
        return true;
      }
      const type1 = value.indexOf('/');
      const type2 = value.indexOf('-');
      const type3 = value.indexOf('.');
      if (type1 !== -1 || type2 !== -1 || type3 !== -1) {
        let parts;
        if (type1 !== -1) {
          parts = value.split('/');
        } else if (type2 !== -1) {
          parts = value.split('-');
        } else {
          parts = value.split('.');
        }
        parts[0] = parseInt(parts[0], 10);
        parts[1] = parseInt(parts[1], 10);
        parts[2] = parseInt(parts[2], 10);
        if (parts[1] > 12) {
          return false;
        }
        return true;
      }
      return false;
    },

    moment(date) {
      return moment(date);
    },

    countryFlag(code) {
      if (code) {
        return `flag-icon-${code.toLowerCase()}`;
      }
      return '';
    },

    async getDuplicateFlagForManual(country, recordtype, recordnumber, product) {
      this.loaderStatus = true;
      const response = await checkDuplicateRegistration({
        country,
        udi: this.finalModelList,
        companyName: this.selectedCompany,
        productName: product,
        account_id: this.account_id,
        registrationId: this.$route.params.id ? this.$route.params.id : null,
        is_new_to_the_market: this.isNewToMarket ? this.isNewToMarket : false,
        certificationNumber: this.submissionNumber,
      });
      this.loaderStatus = false;
      if (response && response.errors) {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.errors.message,
          group: 'custom-notification'
        });
      } else if (response) {
        this.dup_FlagForManual = response.is_duplicate;
      } /// /else condition ends for checking duplicate while saving
      return this.dup_FlagForManual;
    },
    async onRegistrationTypeSelect(selectedType) {
      this.tagAdded = false;
      this.selectedDeviceClass = '';
      this.deviceList = [];
      this.deviceClassList = [];
      this.deviceList = await getProductClass(selectedType.id);
      this.deviceList.forEach((data) => {
        this.deviceClassList.push(data.name);
      });
      this.selectedRegistrationType = selectedType;
      localStorage.setItem('registrationType', this.selectedRegistrationType.id);
      this.$emit('selectedRegistrationType', this.selectedRegistrationType.id);
    },

    async onProductClassSelect(value) {
      const res = await getMaintenanceCyclePerOrdinance(this.deviceList.find((device) => device.name === value).id);
      this.maintenance_cycle_days = res.maintenance_cycle_days;
    },

    onImportedProductSelect(value) {
      const yes = true;
      const no = false;
      this.backendSelectedImportedProduct = value === 'Yes' || value === 'Sim' ? yes : no;
    },
    onRelatedProductSelect(relatedProduct) {
      this.relatedProduct = relatedProduct;
    },

    async onCountrySelect(selectedCountry) {
      if (Object.keys(selectedCountry).length === 0) {
        this.selectedCountry = {};
        return;
      }
      const selectedfromlist = selectedCountry.country_name;

      //* *Adding New features for Selecting Certificate type**
      this.allCerticateType = '';
      this.certificateTypeList = [];
      this.allCerticateTypeNotAuthorized = [];
      this.authorisedSeparator = true;
      this.countryCertificateType.sort((a, b) => a.authorised - b.authorised);
      this.countryCertificateType.forEach((i) => {
        if (i.country_name === selectedfromlist) {
          if (this.authorisedSeparator && i.authorised === 0) {
            this.allCerticateTypeNotAuthorized = `${i.certificate_type},Other Records`;
            this.authorisedSeparator = false;
          }
          if (i.authorised === 0) {
            if (this.allCerticateTypeNotAuthorized.indexOf(i.certificate_type) === -1) {
              this.allCerticateTypeNotAuthorized = `${i.certificate_type},${this.allCerticateTypeNotAuthorized}`;
            }
          } else if (i.authorised === 1) {
            this.allCerticateType = `${i.certificate_type},${this.allCerticateType}`;
          } else {
            // this.allCerticateType = 'No Certificates found'
          }
        }
      });
      if (this.allCerticateType !== '') {
        this.certificateTypeList = this.allCerticateType.split(',');
      }
      if (this.allCerticateTypeNotAuthorized !== '' && this.allCerticateTypeNotAuthorized.length > 0) {
        this.allCerticateTypeNotAuthorized = this.allCerticateTypeNotAuthorized.split(',').reverse();
      }
      this.certificateTypeList = this.certificateTypeList.concat(this.allCerticateTypeNotAuthorized);

      if (Object.keys(selectedCountry).length === 0) {
        this.selectedCountry = {};
        return;
      }
      this.selectedMedCompContact = '';
      this.selectedCountry = selectedCountry;
    },
    async saveRegistration(valueOfSaveDraft) {
      this.loaderStatus = true;
      this.manualErrorData = [];
      let tempProductNameList = '';
      this.devicePartNumber = '';
      let finalPartList = '';
      for (let i = 0; i < this.multiPartValue.length; i += 1) {
        if (i !== 0) {
          if (this.multiPartOptions.indexOf(this.multiPartValue[i]) === -1 && this.multiPartValue[i].multi) {
            finalPartList = `${this.multiPartValue[i].multi},${finalPartList}`;
          } else {
            finalPartList = `${this.multiPartValue[i]},${finalPartList}`;
          }
        } else if (this.multiPartOptions.indexOf(this.multiPartValue[i]) === -1 && this.multiPartValue[i].multi) {
          finalPartList = this.multiPartValue[i].multi;
        } else {
          finalPartList = this.multiPartValue[i];
        }
      }
      this.devicePartNumber = finalPartList;
      if (this.selectedProduct) {
        tempProductNameList = this.selectedProduct.toString();
      }

      const selectedRegistrationType = {
        id: this.selectedRegistrationType.id,
        name: this.selectedRegistrationType.name
      };
      if (this.tagAdded) {
        this.userEnteredRegistrationType = {
          id: this.selectedRegistrationType[0].id,
          name: this.selectedRegistrationType[0].name
        };
      }
      const fields = {
        approval_date: this.approvalDate ? moment(this.approvalDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
        category_source_id: this.selectedCountry.category_source_id,
        comments: this.comments,
        country_code: this.selectedCountry.country_code,
        country_id: this.selectedCountry.country_id ? this.selectedCountry.country_id : this.selectedCountry.id,
        country_name: this.selectedCountry.country_name,
        medCompContact: this.selectedMedCompContact, // this.selectedMedCompContact.fullname
        localRepresentative: this.selectedLocalRepresentative, // this.selectedLocalRepresentative.distributor_name
        distributor_name: this.selectedLocalDistributor,
        expiration_date: this.expirationDate ? moment(this.expirationDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
        product_name: tempProductNameList,
        product_class: this.selectedDeviceClass,
        product_class_id: this.selectedDeviceClass ? this.deviceList.filter((item) => item.name === this.selectedDeviceClass)[0].id : null,
        product_family_name: this.selectedProductFamily
          ? moment(this.selectedProductFamily).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          : '',
        product_type_name: this.selectedProductType,
        registration_number: this.registrationNumber,
        submission_date: this.submissionDate ? moment(this.submissionDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
        udi: this.finalModelList,
        notYetApprovedStatus: false,
        doesNotExpireStatus: false,
        barcode: this.devicePartNumber,
        companyName: this.selectedCompany,
        alertBeforeMonths: this.alertBeforeMonths,
        configuration: this.configuration,
        registration_type: !this.tagAdded ? selectedRegistrationType : this.userEnteredRegistrationType,
        submission_number: this.submissionNumber,
        authorised: this.authorised,
        issued_by: this.issuedBy,
        role_id: this.roleId,
        standards: this.standards,
        ordinance: this.ordinance,
        imported_product: this.backendSelectedImportedProduct,
        requester: this.requester,
        importer: this.importer,
        trade_representative: this.tradeRepresentative,
        inputStatus: this.inputStatus,
        test_report: this.test_report,
        product_certificate: this.product_certificate,
        barcodeFile: this.barcodeFile,
        plantLocationId: this.selectedManufacturingAddress,
        save_draft: this.save_draft,
        next_maintenance_date: this.next_maintenance_date ? moment(this.next_maintenance_date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : ''
      };
      // fields.deleted_file_ids = [];
      if (valueOfSaveDraft) {
        this.save_draft = true;
        fields.save_draft = this.save_draft;
      } else {
        fields.save_draft = false;
      }
      if (this.$route.params.id) {
        if (valueOfSaveDraft) {
          this.save_draft = true;
          fields.save_draft = this.save_draft;
        } else {
          fields.save_draft = false;
        }
        fields.issuedBy = this.issuedBy;
        fields.registration_id = Number(this.$route.params.id);
        const registrationTypeNameWithId = this.registrationTypeList.filter(
          (item) => item.name === this.selectedRegistrationType.name
        )[0];
        if (!this.tagAdded) {
          fields.registration_type = registrationTypeNameWithId ? { id: registrationTypeNameWithId.id, name: registrationTypeNameWithId.name } : null;
        } else {
          fields.registration_type = {
            id: this.selectedRegistrationType[0].id,
            name: this.selectedRegistrationType[0].name
          };
        }
        fields.medCompContact = this.medCompContact;
        fields.todo_checklist_complete = this.todo_checklist_complete;
        fields.isNewToMarket = this.isNewToMarket ? this.isNewToMarket : false;
        if (this.selectedRegistration.issueStatus === 'In Progress') {
          fields.isJustResolved = true;
        }
        let response = {};
        if (this.invalidRecord) {
          fields.accredited_by_id = this.issuedBy ? this.certificateIssuerList.find((cer) => cer.certificate_issued_by === this.issuedBy).id : '';
          fields.alert_date = this.alertBeforeMonths;
          fields.brand_name = this.selectedLocalDistributor;
          fields.certification_number = this.submissionNumber;
          fields.certification_url = this.registrationNumber;
          fields.description = this.configuration;
          fields.deleted_file_ids = this.deletedIds ? this.deletedIds : [];
          fields.status = this.inputStatus;
          fields.revision_date = this.selectedProductFamily
            ? moment(this.selectedProductFamily).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
            : '';
          fields.product_category_id = !this.tagAdded ? selectedRegistrationType.id : this.userEnteredRegistrationType?.id;
          fields.plant_location_id = this.selectedManufacturingAddress;
          fields.model_name = this.finalModelList;
          fields.manufacturer = this.selectedCompany;
          fields.registration_date = this.submissionDate ? moment(this.submissionDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '';
          fields.managed_by = this.selectedLocalRepresentative;
          fields.issue_date = this.approvalDate ? moment(this.approvalDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '';
          response = await editBulkRegistration(this.$route.params.id, fields, this.fileArrayObject);
        } else {
          fields.deleted_file_ids = this.deletedIds ? this.deletedIds : [];
          response = await editRegistration(fields, this.reviewCertificate, this.fileArrayObject);
        }
        if (response.status_code_value === 200 || response.status === 200) {
          this.clearNotifcations();
          if (valueOfSaveDraft) {
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: (this.$i18n.locale === 'Portuguese') ? 'Certificado salvo como Rascunho!' : 'Certificate saved as Draft!',
              group: 'custom-notification'
            });
          } else {
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text:
                  this.$i18n.locale === 'Portuguese' ? 'Certificado atualizado com sucesso!' : 'Certificate updated successfully!',
              group: 'custom-notification'
            });
          }
          this.loaderStatus = false;
          if (this.reviewCertificate) {
            this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua próxima data de manutenção programada é ${moment(this.next_maintenance_date).format('DD/MM/YYYY')}.` : `Your next scheduled maintenance date is ${moment(this.next_maintenance_date).format('MM/DD/YYYY')}.`;
            if (new Date(this.suggestedMaintenenceDate) < new Date(this.next_maintenance_date)) this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua próxima data de manutenção programada ${moment(this.next_maintenance_date).format('DD/MM/YYYY')}  é posterior à data sugerida, o que representa um risco para o produto até ser reconhecido.` : `Your next scheduled maintenance date ${moment(this.next_maintenance_date).format('MM/DD/YYYY')} is later than the suggested date, which poses a risk to the product until acknowledged.`;
            $('#deleteRecord').modal('show');
          }
          if (valueOfSaveDraft) {
            this.$router.push({ name: 'Registration' });
          } else if (this.$route.query.type === 'false' || this.$route.query.type === false) {
            this.$router.push({ name: 'Registration' });
          } else {
            this.$emit('submit');
            this.$router.push(`/layout/registration/flow/regulation-check/${fields.registration_type.id}/${this.registrationId}`);
          }
        } else if (response.status_code_value === 500 && response.body.message === 'No change to update') {
          this.manualErrorData = response.errors;
          this.clearNotifcations();
          this.$notify({
            type: 'warning',
            title: this.$i18n.locale === 'Portuguese' ? 'Aviso' : 'Warning',
            text: this.$i18n.locale === 'Portuguese' ? 'Nenhuma mudança para atualizar!' : 'No change to update!',
            group: 'custom-notification'
          });
          this.certificateValue = [];
          this.loaderStatus = false;
          if (this.$route.query.type === 'false' || this.$route.query.type === false) {
            this.$router.push({ name: 'Registration' });
          } else {
            this.$emit('submit');
            this.$router.push(`/layout/registration/flow/regulation-check/${fields.registration_type.id}/${this.registrationId}`);
          }
          this.currentSlider += 1;
          if (this.reviewCertificate) {
            this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua próxima data de manutenção programada é ${moment(this.next_maintenance_date).format('DD/MM/YYYY')}.` : `Your next scheduled maintenance date is ${moment(this.next_maintenance_date).format('MM/DD/YYYY')}.`;
            if (new Date(this.suggestedMaintenenceDate) < new Date(this.next_maintenance_date)) this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua próxima data de manutenção programada ${moment(this.next_maintenance_date).format('DD/MM/YYYY')}  é posterior à data sugerida, o que representa um risco para o produto até ser reconhecido.` : `Your next scheduled maintenance date ${moment(this.next_maintenance_date).format('MM/DD/YYYY')} is later than the suggested date, which poses a risk to the product until acknowledged.`;
            $('#deleteRecord').modal('show');
          }
          this.revision = response.body.revision;
        } else {
          this.manualErrorData = response.errors;
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Nenhuma mudança para atualizar!' : 'Editing record failed!',
            group: 'custom-notification'
          });
          this.certificateValue = [];
          this.loaderStatus = false;
        }
        this.registrationId = this.$route.params.id;
      } else {
        this.add = true;
        const response = await saveRegistrationDetails(fields, this.newToMarket, this.fileArrayObject);
        if (response.status_code === 200) {
          this.clearNotifcations();
          if (valueOfSaveDraft) {
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: (this.$i18n.locale === 'Portuguese') ? 'Certificado salvo como Rascunho!' : 'Certificate saved as Draft!',
              group: 'custom-notification'
            });
            this.$router.push({ name: 'Registration' });
          } else {
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: (this.$i18n.locale === 'Portuguese') ? 'Certificado salvo com sucesso!' : 'Certificate saved successfully!',
              group: 'custom-notification'
            });
          }
          this.registrationId = response.saveAllData[0].registration_id;
          this.revision = response.saveAllData[0].revision;
          this.$emit('submit');
          this.loaderStatus = false;
          if (valueOfSaveDraft) {
            this.$router.push({ name: 'Registration' });
          } else if (this.$route.query.type === 'false' || this.$route.query.type === false) {
            this.$router.push({ name: 'Registration' });
          } else if (!this.$route.params.id) this.$router.push(`/layout/registration/flow/regulation-check/${this.selectedRegistrationType.id}/${this.registrationId}`);
        } else {
          this.manualErrorData = response.errors;
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Falha ao salvar o produto!' : 'Saving product Failed!',
            group: 'custom-notification'
          });
          this.certificateValue = [];
          this.loaderStatus = false;
        }
      }
    },
    loadNewRegistration(registration, response) {
      const savedRegistration = registration;
      savedRegistration.attachmentLinks = savedRegistration.attachmentLinks ? savedRegistration.attachmentLinks : '';
      savedRegistration.registration_id = response.saveAllData[0].registration_id;
      savedRegistration.local_representative = savedRegistration.localRepresentative
        ? savedRegistration.localRepresentative
        : null;
      savedRegistration.product_family = savedRegistration.product_family_name
        ? savedRegistration.product_family_name
        : null;
      savedRegistration.product_type = savedRegistration.product_type_name ? savedRegistration.product_type_name : null;
      savedRegistration.registrationType = this.selectedRegistrationType ? this.selectedRegistrationType.name : null;
      savedRegistration.registrationCompany = savedRegistration.companyName ? savedRegistration.companyName : null;
      savedRegistration.related_certificate = this.selectedRelatedCertificateNames
        ? this.selectedRelatedCertificateNames.join()
        : null;
      savedRegistration.product_class = this.selected_product_device_class ? this.selected_product_device_class : null;
      savedRegistration.status = response.saveAllData[0].expiryStatus;
      this.$emit('loadRegistrationDataafterAdd', {
        saveAllData: [savedRegistration]
      });
    },
    resetAddRecordManualForm() {
      this.selectedProduct = '';
      this.selectedCountry = [];
      this.selectedRegistrationType = [];
      // TODO : remove this assignment
      this.selectedCompany = '';
      this.registrationNumber = '';
      this.recordTypeName = '';
      this.selectedDeviceClass = '';
    },

    proceedToAddNTMProduct(valueOfSaveDraft) {
      this.saveRecord(valueOfSaveDraft);
    },

    cancelAdd() {
      this.$emit('cancelAdd');
      $('#addRecordPopup').modal('hide');
    },

    checkForNTMProduct(valueOfSaveDraft) {
      const { path } = this.$route;
      const isIdInUrl = path.split('/')[path.split('/').length - 1];
      if (!this.todo_checklist_complete && isIdInUrl === 'add-record') {
        this.promptMsg = this.$i18n.locale === 'English' ? 'By going to the next step, your entered data will be saved, but some of the data can not be changed (Product Name, Product class, Product Category)' : 'Ao seguir para a próxima etapa, seus dados inseridos serão salvos, mas alguns dos dados não podem ser alterados (Nome do Produto, classe de produto e categoria de produto)';
        $('#addRecordPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (this.isNewToMarket && this.expirationDate) {
        this.promptMsg = this.$i18n.locale === 'English' ? 'By going to the next step, your entered data will be saved, but some of the data can not be changed (Product Name, Product class, Product Category & Expiration date)' : 'Ao seguir para a próxima etapa, seus dados inseridos serão salvos, mas alguns dos dados não podem ser alterados (Nome do Produto, classe de produto, categoria de produto e data de validade)';
        $('#addRecordPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.saveRecord(valueOfSaveDraft);
      }
    },

    saveRecordAsDraft(valueOfSaveDraft) {
      this.saveRecord(valueOfSaveDraft);
    },

    async saveRecord(valueOfSaveDraft) {
      this.loaderStatus = true;
      const modelList = [];
      const modelNames = this.deviceUdi;
      if (modelNames.length > 0) {
        for (let i = 0; i < modelNames.length; i += 1) {
          if (modelNames[i].multi) {
            modelList.push(modelNames[i].multi);
          } else {
            modelList.push(modelNames[i]);
          }
        }
      }
      this.finalModelList = modelList.toString();
      await this.validateRecordsSize();
      this.loaderStatus = false;
      if (this.recordTypeName === '' || !this.recordTypeName) {
        this.recordTypeName = '-';
      }
      // if (this.registrationNumber === '') {
      //   this.registrationNumber = '-';
      // }
      if (!valueOfSaveDraft) {
        await this.getDuplicateFlagForManual(
          this.selectedCountry.country_name,
          this.recordTypeName,
          this.registrationNumber,
          this.selectedProduct.toString()
        );
        if (this.dup_FlagForManual === true) {
          this.deleteWarningInfo.loaderStatus = false;
          this.headerTitle = this.$i18n.locale === 'Portuguese' ? 'Certificado Duplicado' : 'Duplicate Certificate';
          this.deleteWarningInfo.title = this.$i18n.locale === 'Portuguese' ? 'Confirmar duplicado' : 'Confirm Duplicate';
          this.confirmMessage =
              this.$i18n.locale === 'Portuguese'
                ? 'Verifique e confirme se deseja prosseguir.'
                : 'Please check and confirm if you would like to proceed.';
          this.deleteWarningInfo.customMessage =
              this.$i18n.locale === 'Portuguese'
                ? 'Os detalhes inseridos contêm dados duplicados de um certificado existente.'
                : 'Entered details contain duplicate data from an existing certificate.';
          $('#modal_delete').modal({
            backdrop: 'static',
            keyboard: false
          });
          this.duplicateChkFlag = false;
          return;
        }
      }
      this.saveRegistration(valueOfSaveDraft);
    },
    saveDuplicateRecord() {
      this.dup_FlagForManual = false;
      $('#modal_delete').modal('hide');
      this.saveRegistration();
    },

    async initialAPICalls() {
      this.loaderStatus = true;
      await axios
        .all([
          getMedCompContacts(),
          getProductList(),
          getRegistrationTypeList(),
          getLocalDistributor(),
          getProductPartNumber(),
          getLocalRepresentative(),
          getProductFamily(),
          getCertificateList(),
          getCertificateIssuerList(),
          getCountryCertificateAuth(),
        ])
        .then(
          axios.spread(
            (
              medCompContactList,
              productList,
              registrationTypeList,
              localDistributor,
              productPartNumber,
              localRepresentative,
              productFamilyList,
              certificateList,
              certificateIssuerList,
              countryCertificateAuth,
            ) => {
              this.loaderStatus = false;
              this.medCompContactListByName = medCompContactList.map((each) => each.contact_name);
              this.productListByName = [];
              this.multipleProductNames = [];
              this.multipleProductNameList = [];
              productList.forEach((data) => {
                if (data.product_name !== null) {
                  if (data.product_name.indexOf(',') > -1) {
                    this.multipleProductNameList.push(data.product_name);
                    this.productListByName.push(data.product_name);
                    this.multipleProductNames.push({
                      product_name: data.product_name
                    });
                  } else {
                    this.productListByName.push(data.product_name);
                    this.multipleProductNameList.push(data.product_name);
                    this.multipleProductNames.push({
                      product_name: data.product_name
                    });
                  }
                }
              });
              this.registrationTypeList = registrationTypeList;
              this.multiOptions = localDistributor.map((each) => each.distributor_name);
              if (productPartNumber.result) this.multiPartOptions = productPartNumber.result;
              this.localRepresentativeListByName = localRepresentative.map((each) => each.localRepresentative);
              this.productFamilyListByName = productFamilyList.map((each) => each.product_family);
              this.relatedCertificateList = certificateList.filter(
                (certificate) => certificate.certificateNumber !== '-'
              );
              this.certificateIssuerList = certificateIssuerList;
              this.certificateIssuedByList = certificateIssuerList.map((each) => each.certificate_issued_by);
              this.certificateCountryList = [];
              this.countryCertificateType = [];
              this.certificateCountryManual = [];
              this.countryCertificateType = countryCertificateAuth;
              countryCertificateAuth.forEach((i) => {
                if (this.certificateCountryList.indexOf(i.country_id) === -1) {
                  this.certificateCountryList.push(i.country_name);
                  this.certificateCountryManual.push({
                    country_name: i.country_name
                  });
                }
              });
            }
          )
        );
    },
    translateData() {
      if (this.$i18n.locale === 'Portuguese') {
        this.translatedExcelColumnInfo = this.importExcelColumnInfoPortuguese;
        this.slidesInfo = [{ title: 'Detalhes do registro' }, { title: 'Anexos' }];
        this.managedByList = ['Auto', 'UL', 'Outros'];
        this.importedProduct = ['Sim', 'Não'];
        this.newPageStatus = ['Ativo', 'Suspenso', 'Cancelado'];
      } else {
        this.translatedExcelColumnInfo = this.importExcelColumnInfo;
        this.slidesInfo = [{ title: 'Registration Details' }, { title: 'Attachments' }];
        this.managedByList = ['Self', 'UL', 'Others'];
        this.importedProduct = ['Yes', 'No'];
        this.newPageStatus = ['Active', 'Suspended', 'Cancelled'];
      }
    },
    updateselectedProductFamily() {
      if (this.selectedProductFamily) {
        $(`#${this.genericPopupId}`).modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    }
  },
  async created() {
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    this.$i18n.locale = localStorage.getItem('language');
    this.translatedExcelColumnInfo = this.importExcelColumnInfo;
    this.translateData();
    this.getPermissions();
    await this.getPlantLocations();
    if (this.$route.query) {
      if (this.$route.query.type === 'true' || this.$route.query.type === true) {
        this.newToMarket = true;
        this.todo_checklist_complete = false;
      } else if (this.$route.query.invalidRecord && this.$route.query.invalidRecord.toString() === 'true') {
        this.invalidRecord = true;
        this.newToMarket = false;
        this.todo_checklist_complete = true;
      } else if (this.$route.query.isReview && this.$route.query.isReview.toString() === 'true') {
        this.reviewCertificate = true;
        this.newToMarket = false;
        this.todo_checklist_complete = true;
        this.attachmentTypeList.push({ id: 4, tabName: 'Maintenance Documents' });
      } else {
        this.newToMarket = false;
        this.todo_checklist_complete = true;
        this.invalidRecord = false;
      }
    }
    this.regId = this.$route.params.id;
    EventBus.$on('activeMenuTitle', () => {
      this.translateData();
    });
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    EventBus.$on('updateManufacturingAddress', () => {
      if (this.addressData) this.selectedManufacturingAddress = this.addressData.plantLocationId;
      else this.selectedManufacturingAddress = null;
    });
    this.account_id = JSON.parse(localStorage.getItem('userData')).account_id;
    EventBus.$on('updateAddRecordAttachments', (version) => {
      version.forEach((fileItem) => {
        this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName] = this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName] || [];
        const fileExists = this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName].find((x) => x.fileName === fileItem.name);
        if (fileExists) {
          this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName][0].file = fileItem;
        } else {
          this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName].push({ attachmentId: '', file: fileItem, fileName: fileItem.name });
        }
      });

      this.fileArrayObject[this.attachmentTypeList[this.tableActiveTab - 1].tabName].forEach((fileItem, index) => {
        fileItem.attachmentId = index + 1;
      });
      // await this.getFiles();
    });
    EventBus.$on('updatePlantLocation', async () => {
      await this.getPlantLocations();
      this.selectedManufacturingAddress = this.multiPlantAddresses[this.multiPlantAddresses.length - 2].plantLocationId;
    });
    this.loggedInUser = JSON.parse(localStorage.getItem('userData'));
    this.role_id = this.loggedInUser.role_id;
  },
  beforeDestroy() {
    EventBus.$off('updateLanguage');
    EventBus.$off('updateManufacturingAddress');
    EventBus.$off('updatePlantLocation');
  }
};
</script>

  <style scoped>

  .primary-default-text-color {
    color: #3E3E3E;
  }

  .form-header-styling {
    text-decoration: none;
    color: #000000;
    line-height: 34px;
    font-size: 24px;
    padding-left: 40px;
    background: #EBEBEB;
    border-bottom: 1px solid #B3B3B3;
  }

  .form-header-styling.form-header-text {
    border-bottom: unset;
    padding-left: 16px;
  }
  .modal-footer {
      background-color: #fafaf9 !important;
      padding-right: 0px;
      border: none !important;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
  }
  .modal-content {
   border: none;
   border-top-right-radius: 6px!important;
   border-top-left-radius: 6px!important;
   border-bottom-right-radius: 0!important;
   border-bottom-left-radius: 0!important;
  }
  .pr-28 {
    padding-right: 28px;
  }
  .step-measure {
    color: #2A313A;
  }
  .mb-8 {
    margin-bottom: 8px;
  }
  .form-separator {
    border: 1px solid #0000001f;
    margin-left: 36px;
    width: calc(100% - 36px);
    margin-bottom: 24px;
  }

  .form-separator.default-search-table {
    margin-left: 0;
    width: 100%;
    margin-bottom: 40px;
  }

  /* .text-area.description-section {
    margin-bottom: 24px;
  } */

  .text-area .form-group {
    margin-bottom: 24px;
  }
  .attachment-list:nth-child(even) {
    background: #f5f5f5;
  }

  .attachment-list:nth-child(odd) {
    background: #fafafa;
  }
  .attachment-wrapper {
    background: #e6e6e6;
  }

  .h-100 {
    min-height: 100vh;
  }

  .footer-btns {
    position: relative;
    bottom: 0px;
    position: relative;
    background: #fff;
    padding: 24px;
    border-top: 1px solid #B3B3B3;
  }
  .stepper-wrapper {
    margin-bottom: 36px;
  }
  .form-fields-wrapper {
    border: 1px solid #b3b3b3;
    background: #fff;
    min-height: 100vh;
    padding: 40px 40px 24px 40px;
  }

  .single-field {
    padding-right: 28px;
  }

  .col-gap-26 {
    column-gap: 26px;
  }

  .record-type {
    color: #000000;
    line-height: 34px;
    font-size: 24px;
  }

  .form-wrapper {
    /* min-height: 100vh; */
    background: #F5F5F5;
  }

  .progress-stepper {
    height: 8px;
    background: #e6e6e6;
  }

  .progress-stepper.active {
    background: #0a99ff;
  }

  /* .brand-name-section .dropdown,
  .relatedRecordsSection .dropdown,
  .partNumberSection .dropdown{
    z-index: 10;
  } */
  .uploaded-file-confidential {
    display: flex;
    /* flex-direction: row; */
    column-gap: 36px;
  }
  .brand-name-section .dropdown.open .dropdown-toggle.clearfix,
  .relatedRecordsSection .dropdown.open .dropdown-toggle.clearfix,
  .partNumberSection .dropdown.open .dropdown-toggle.clearfix {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-bottom: 0px !important;
  }
  .brand-name-section .dropdown.open .dropdown-menu,
  .relatedRecordsSection .dropdown.open .dropdown-menu,
  .partNumberSection .dropdown.open .dropdown-menu {
    border-top: 0px !important;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }
  .brand-name-section .dropdown.open .dropdown-toggle:before,
  .relatedRecordsSection .dropdown.open .dropdown-toggle:before,
  .partNumberSection .dropdown.open .dropdown-toggle:before {
    content: '';
    display: flex;
    align-items: center;
    position: absolute !important;
    bottom: 0px;
    left: 10px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity: 0.5;
    width: 96%;
  }
  .brand-name-section .dropdown.open.searching .dropdown-toggle,
  .relatedRecordsSection .dropdown.open.searching .dropdown-toggle,
  .partNumberSection .dropdown.open.searching .dropdown-toggle {
    border: 0.5px solid black !important;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
  }
  .brand-name-section .dropdown-menu,
  .relatedRecordsSection .dropdown-menu,
  .partNumberSection .dropdown-menu {
    max-height: 229px !important;
  }
  .brand-name-section .dropdown-menu > li > a,
  .relatedRecordsSection .dropdown-menu > li > a,
  .partNumberSection .dropdown-menu > li > a {
    padding: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #4d4d4d;
  }
  .brand-name-section .dropdown-menu > li,
  .relatedRecordsSection .dropdown-menu > li,
  .partNumberSection .dropdown-menu > li {
    margin-top: 10px;
  }
  .brand-name-section .dropdown-menu li:hover,
  .relatedRecordsSection .dropdown-menu li:hover,
  .partNumberSection .dropdown-menu li:hover {
    border:1px solid #0A99ff !important;
  }
  .brand-name-section .dropdown.open .dropdown-menu::-webkit-scrollbar,
  .relatedRecordsSection .dropdown.open .dropdown-menu::-webkit-scrollbar,
  .partNumberSection .dropdown.open .dropdown-menu::-webkit-scrollbar {
    width: 8px;
  }
  .brand-name-section .dropdown.open .dropdown-menu::-webkit-scrollbar-thumb,
  .relatedRecordsSection .dropdown.open .dropdown-menu::-webkit-scrollbar-thumb,
  .partNumberSection .dropdown.open .dropdown-menu::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 18px !important;
  }
  @media screen and (min-width: 1300px) {
    .relatedRecordsSection .dropdown.open .dropdown-menu:before,
    .partNumberSection .dropdown.open .dropdown-menu:before {
      left: 12px;
    }
  }
  .related-product-section .ui.selection.active.dropdown .menu {
    min-width: calc(100% + 1px);
  }
  @media screen and (min-width: 1301px) and (max-width: 1399px) {
    .related-product-section .ui.selection.active.dropdown .menu {
      min-width: calc(100% + 2px);
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1300px) {
    .related-product-section .ui.selection.active.dropdown .menu {
      min-width: calc(100% + 2px);
    }
  }
  @media screen and (min-width: 1301px) and (max-width: 1399px) {
    .ui.selection.active.dropdown .menu {
      min-width: calc(100% + 2px);
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1300px) {
    .ui.selection.active.dropdown .menu {
      min-width: calc(100% + 1.5px);
    }
  }

  /* label>input[type="radio"]:checked+* {
    color: #01518a;
  } */
  .product-category-ellipsis.ui.selection.dropdown.list-select-class .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 95%;
  }
  .ui.selection.dropdown.list-select-class {
    cursor: pointer;
  }
  .ui.selection.dropdown.list-select-class .text.default {
    color: #828282 !important;
  }
  .ui.selection.active.dropdown:hover {
    border: 0.5px solid #000000;
    border-bottom: none;
  }
  .ui.selection.dropdown:hover {
    border-color: #000000 !important;
  }
  .ui.selection.active.dropdown {
    border-color: #000000 !important;
  }
  .ui.selection.active.dropdown .menu {
    border-color: #000000 !important;
  }
  .ui.selection.active.dropdown:hover .menu {
    border-color: #000000 !important;
    border: 0.5px solid #000000;
    border-top: none;
  }
  .ui.dropdown .menu > .item:hover {
    border:1px solid #0A99ff !important;
  }
  .ui.dropdown .menu > .item.current {
    font-weight: 600 !important;
    color: #4d4d4d !important;
    border:1px solid #0A99ff !important;
  }
  .ui.selection.active.dropdown .menu {
    width: 100%;
    /* min-width: 100%; */
    max-height: 229px !important;
    padding-top: 6px;
  }
  .list-select-class.active:before {
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    top: 34px;
    left: 10px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity: 0.5;
    width: 97%;
  }
  .list-select-class .menu > .item {
    color: #4d4d4d !important;
    font-size: 18px !important;
    font-weight: 300 !important;
    line-height: 25px !important;
    cursor: pointer;
  }
  .list-select-class.ui.search.dropdown > .text {
    color: #4d4d4d;
  }
  .ui.selection.active.dropdown > .search {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #4d4d4d;
  }
  .list-select-class.ui.active.search.dropdown input.search:focus + .text {
    color: #4d4d4d !important;
  }
  .menu .item {
    border: none !important;
  }

  .list-select-class::after {
    content: '';
    float: right;
    right: 15px;
    position: absolute;
    top: 6px;
    border: 1px solid #000000;
    padding: 7px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border-width: 0 1px 1px 0;
  }
  .list-select-class.active.visible:after {
    transform: rotate(225deg) !important;
    top: 16px;
  }
  .ui.search.dropdown .menu::-webkit-scrollbar {
    width: 8px;
  }
  .ui.search.dropdown .menu::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 18px !important;
  }
  /* .ui.dropdown > .dropdown.icon:before{
    content: "" !important;
    float: right;
    right: 15px;
    position: absolute;
    top: 6px;
    border: 1px solid #000000;
    padding: 7px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border-width: 0 1px 1px 0;
  } */

  .list-select-class .icon {
    display: none;
  }
  .brand-name-section .dropdown .open-indicator,
  .relatedRecordsSection .dropdown .open-indicator,
  .partNumberSection .dropdown .open-indicator {
    left: 94% !important;
  }
  .brand-name-section .dropdown.open.border-required .dropdown-toggle.clearfix,
  .relatedRecordsSection .dropdown.open.border-required .dropdown-toggle.clearfix,
  .partNumberSection .dropdown.open.border-required .dropdown-toggle.clearfix {
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    border: 0.5px solid #000000 !important;
  }
  </style>

  <style scoped>
  .product-class-ellipsis.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select {
    padding-top: 0px !important;
  }
  label > input[type='radio'] {
    display: none;
  }

  label > input[type='radio'] + *::before {
    content: '';
    cursor: pointer;
    display: inline-block;
    vertical-align: bottom;
    width: 18px;
    height: 18px;
    margin-right: 12px;
    margin-bottom: 4px;
    border-radius: 50%;
    border-style: solid;
    border-width: 2px;
    border-color: #4D4D4D;
  }

  label > input[type='radio']:checked + *::before {
    background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
    border-color: #00518a;
  }
  .confidential-label {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;

    /* UL Color / Red */

    color: #b00505;
  }
  .highly-confidential-label {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;

    /* Grays/Dark Gray */

    color: #3e3e3e;
  }
  .expiration-approval-dates-inline-style {
    left: 40px;
    width: 0px !important;
    height: 0px !important;
    top: 0px !important;
  }
  .z-index-1 {
    z-index: 1 !important;
  }
  .z-index-4 {
    z-index: 4 !important;
  }
  .z-index-8 {
    z-index: 8 !important;
  }
  .z-index-9 {
    z-index: 9 !important;
  }

  .z-index-10 {
    z-index: 10 !important;
  }
  .uploaded-file-name {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #3e3e3e;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  /* .attachments-card-outer {
    padding-left: 20px;
  } */
  .info-img {
    margin-right: 17px;
  }
  .uploaded-files-list {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    padding: 12px 0px 12px 24px;
  }
  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 1;
  }
  .arrow.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #b4b4b4;
  }
  .arrow.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #b4b4b4;
  }
  .checkmark {
    top: 1px;
    margin: 0px 0px 0px 40px;
    border: 1px solid #01518a;
    background-color: #fff;
  }
  /* .brand-name-section >>> .v-select-dist .open-indicator:before{
    content: none !important;
  } */
  .brand-name-section >>> input::placeholder,
  .relatedRecordsSection >>> input::placeholder,
  .partNumberSection >>> input::placeholder {
    color: #999999 !important;
    font-weight: 400;
  }
  .crumb-selection {
    z-index: -1;
  }
  .back-btn-position {
    position: absolute;
    left: 297px;
  }
  .addRecord-footer-hr {
    width: 100%;
    margin-left: 321px;
    margin-right: -420px;
    margin-top: -39px;
  }
  .attachments-footer-hr {
    width: 100%;
    margin-left: 320px;
    margin-right: -343px;
    margin-top: -39px;
  }
  .attachments-footer-hr hr,
  .addRecord-footer-hr hr {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .panel-group .panel + .panel {
    margin-top: 24px;
  }
  .dropdown-menu-ul {
    /* left: -150px !important; */
    right: 2px !important;
    left: unset;
  }
  .dropdown-menu-ul::after {
    right: 1em !important;
  }

  .dropdown-menu li {
    padding: 0px;
  }

  .dropdown-menu li:not(:last-child) {
    margin-bottom: 16px;
  }
  .dropdown-menu {
    /* left: -15px; */
    width: 142px;
    filter: drop-shadow(0px 0px 10px #b2b2b2);
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
    /* border-radius: 5px; */
    /* border: none; */
    top: 34px !important;
    padding: 20px;
    background: #ffffff;
    border: 1px solid #d3d3d3;
    border-radius: 0px 0px 4px 4px;
  }
  .tracker-images {
    margin-right: 21px;
  }
  .tooltip-pointer li:first-child {
    /* padding-bottom: 18px; */
  }
  .dropdown-menu > li > a {
    padding: 0px;
    display: flex;
    color: rgb(52, 17, 126);
  }
  .dropdown-menu > li > a:focus,
  .dropdown-menu > li > a:hover {
    color: rgb(52, 17, 126);
  }
  .dropdown-menu .divider {
    margin: 0px;
  }
  .tooltip-pointer:before {
    position: absolute;
    top: -12px;
    height: 0;
    width: 0;
    left: 84%;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 12px solid #ffffff;
    content: '';
  }
  .addReverse.tooltip-pointer:after {
    position: absolute;
    bottom: -11px !important;
    height: 0;
    width: 0;
    left: 84%;
    border-left: 9px solid transparent !important;
    border-right: 9px solid transparent !important;
    border-top: 12px solid #ffffff !important;
    content: '';
  }
  .addReverse.tooltip-pointer:before {
    content: none;
  }
  .dropdown-export .export-menu li .MRL-4 {
    margin-left: 4px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #01518a;
  }
  .delete-text {
    color: #b00505 !important;
  }
  .dropdown-export .export-menu li .MRR-4 {
    margin-right: 4px;
  }
  .dropdown-export .export-menu img,
  .viewRegistration img {
    width: 18px;
    vertical-align: sub;
    height: 18px;
  }
  .dropdown-export .export-menu img.unarchive {
    height: 20px;
  }
  .dropdown-export .export-menu span {
    font-size: 14px;
  }
  .product-class-ellipsis.multiselect-single-dropdown,
  .accredited-by-ellipsis.multiselect-single-dropdown,
  .manufacturing-address.multiselect-single-dropdown,
  .product-category-ellipsis.multiselect-single-dropdown {
    width: 100%;
    overflow: hidden;
  }
  .multiselect-single-dropdown.multiselect--active {
    overflow: unset !important;
  }
  .product-class-ellipsis.multiselect-single-dropdown >>> .multiselect__single,
  .accredited-by-ellipsis.multiselect-single-dropdown >>> .multiselect__single,
  .manufacturing-address.multiselect-single-dropdown >>> .multiselect__single,
  .product-category-ellipsis.multiselect-single-dropdown >>> .multiselect__single {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-bottom: 0px;
  }
  .multiselect-single-dropdown.multiselect--active::before {
    content: none;
  }
  .multiselect--active >>> .multiselect__tags {
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .multiselect--active >>> .multiselect__option--highlight:after {
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after {
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after {
    content: none !important;
  }
  .multiselect {
    min-height: 36px;
  }
  .multiselect-single-dropdown >>> .multiselect__tags {
    border-radius: 3px;
    height: 44px;
    padding: 12px 40px 12px 16px;
  }
  .multiselect-single-dropdown >>> .multiselect__select {
    padding-top: 6px !important;
  }
  .multiselect-single-dropdown >>> .multiselect__select:before {
    border: 0;
    transform: rotate(0deg);
    /* border: 1px solid #0b3c61; */
    /* border-width: 0 1px 1px 0; */
    display: inline-block;
    padding: 7px;
    top: -6px;
    right: 8px;
    content: url('/static/images/icons/emergo_dropdown_sort.svg');
  }

  ::v-deep .v-select-part .open-indicator:before {
    border: 0;
  }

  .multiselect-single-dropdown.multiselect--active >>> .multiselect__select:before {
    top: -10px;
    right: 3px;
  }
  .multiselect-single-dropdown >>> .multiselect__option:hover {
    border:1px solid #0A99ff !important;
  }
  .multiselect-single-dropdown >>> .multiselect__option span:hover {
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown >>> .multiselect__content .multiselect__element span:hover {
    /* font-weight: 600 !important; */
  }
  .multiselect--active >>> .multiselect__select {
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown >>> .multiselect__content-wrapper .multiselect__option--highlight {
    /* background: #e6e6e6 !important; */
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown >>> .multiselect__content-wrapper .multiselect__option--highlight span {
    /* font-weight: 600 !important; */
  }
  .remove-selected-bg-color.multiselect-single-dropdown.multiselect--active >>> .multiselect__option--selected,
  .remove-selected-bg-color.multiselect-single-dropdown
    >>> .multiselect__content-wrapper
    .multiselect__option--highlight.multiselect__option--selected,
  .accredited-by-ellipsis.multiselect-single-dropdown.multiselect--active >>> .multiselect__option--selected,
  .accredited-by-ellipsis.multiselect-single-dropdown
    >>> .multiselect__content-wrapper
    .multiselect__option--highlight.multiselect__option--selected,
  .product-class-ellipsis.multiselect-single-dropdown.multiselect--active >>> .multiselect__option--selected,
  .product-class-ellipsis.multiselect-single-dropdown
    >>> .multiselect__content-wrapper
    .multiselect__option--highlight.multiselect__option--selected {
    background: #ffffff;
    border: 1px solid #0A99ff;
  }
   .multiselect-single-dropdown.multiselect--active
    >>> .multiselect__option--selected{
      background: #ffffff;
      border: 1px solid #0A99ff;
    }
    .multiselect-single-dropdown.multiselect--active
    >>> .multiselect__option--selected span{
      /* background: #ffffff;
      border: 1px solid #0A99ff; */
    }
  .multiselect-single-dropdown >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active >>> .multiselect__tags::after {
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity: 0.5;
    width: 95%;
  }
  .multiselect-single-dropdown >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #4d4d4d;
    overflow: visible;
    padding-left: 0px;
  }
  .multiselect-single-dropdown >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #999999;
    overflow: visible;
    padding-left: 0px;
  }
  .multiselect--active >>> .multiselect__single,
  .multiselect--active >>> .multiselect__placeholder {
    padding: 4px 40px 4px 12px;
  }
  .multiselect--active >>> .multiselect__input {
    padding-left: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #4d4d4d;
  }
  .multiselect-single-dropdown >>> .multiselect__content {
    margin-top: 5px;
  }
  .multiselect-single-dropdown >>> .multiselect__content .multiselect__element span {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #4d4d4d;
  }
  .multiselect-single-dropdown >>> .multiselect__content .multiselect__element .multiselect__option {
    padding-left: 12px;
    padding-top: 6px;
    padding-bottom: 0px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active >>> .multiselect__tags::before {
      left: 10px;
      width: 94%;
    }
  }
  .multiselect-single-dropdown.multiselect--active >>> .multiselect__content-wrapper {
    border: 1px solid black;
    border-top: none;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
  }
  .multiselect-single-dropdown >>> .multiselect__content-wrapper {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .mx-datepicker >>> .mx-input-wrapper .mx-icon-clear {
    left: 10px;
    height: 16px;
    width: 16px;
  }
  .date-fields .mx-datepicker >>> .mx-input {
    border: 1px solid #4d4d4d;
    padding-left: 36px;
    height: 44px;
    font-size: 16px;
    color: #4d4d4d;
    font-weight: 300;
  }
  .date-fields .mx-datepicker >>> .mx-input::placeholder {
    color: #999999;
    font-weight: 400;
  }
  .date-fields .mx-datepicker >>> .mx-input-wrapper .mx-icon-calendar {
    left: 6px;
    right:auto
  }
  .ml-12 {
    margin-left: 12px;
  }
  .width {
    width: 100%;
  }
  .ui.search.selection.dropdown > input.search {
    line-height: 25px;
  }
  .ui.search.dropdown {
    border: 0.5px solid #000000;
    border-radius: 3px;
  }
  .ui.selection.dropdown {
    padding: 4px 12px !important;
    min-height: 36px;
  }
  /* .attachments-group {
    margin: 0px 26px 180px 51px;
  } */
  .attachments-panel {
    display: grid;
    box-shadow: none !important;
    border-color: #b3b3b3;
  }
  .attachments-panel-child {
    background: transparent !important;
    border-radius: 10px;
  }
  /* .registrationDetails-wrapper{
    padding: 20px;
    overflow-y: auto;
  } */
  .attachments-wrapper-parent {
    margin-left: 25px;
    margin-right: 25px;
  }

  .attachments-container {
  }
  .attachments-wrapper {
    background: #ffffff;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }
  .attach-files-text {
    color: #333333;
    line-height: 33px;
    margin: 0px 0px 5px 0px;
  }
  .file-types-allowed {
    color: #333333;
    margin-bottom: 40px;
  }
  /* .attachments-text {
    padding: 32px 10px 24px 47px;
  } */
  .file-upload-icon {
    padding-right: 8px;
  }
  .attach-file {
    margin-bottom: 0;
    padding-right: 40px;
    font-size: 14px;
    line-height: 25px;
    color: #01518a;
  }
  .file-upload-chevron {
    padding-right: 0px;
    border: none;
    background-color: transparent !important;
    /* padding-top: 20px; */
  }
  .pb-18 {
    padding-bottom: 18px;
  }
  .pr-11 {
    padding-right: 11px !important;
  }
  .pl-56 {
    padding-left: 56px !important;
  }
  .pr-101 {
    padding-right: 101px !important;
  }
  .ml-26 {
    margin-left: 26px;
  }
  .ml-50 {
    margin-left: 50px !important;
  }
  .ml-52 {
    margin-left: 52px !important;
  }
  .pl-16 {
    padding-left: 16px;
  }
  .pb-109 {
    padding-bottom: 109px !important;
  }
  .pl-36 {
    padding-left: 36px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .ml-230 {
    margin-left: 230px;
  }
  .mr-0 {
    margin-right: 0;
  }
  .ml-6 {
    margin-left: 6px;
  }
  .mb-28 {
    margin-bottom: 28px;
  }
  .mt-12 {
    margin-top: 12px;
  }
  .mt-16 {
    margin-top: 16px;
  }
  .mb-24 {
    margin-bottom: 24px;
  }
  .mt-38 {
    margin-top: 38px;
  }
  .mt-6 {
    margin-top: 6px;
  }
  .sub_heading {
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #01518a;
  }
  .heading {
    font-weight: 300;
    font-size: 36px;
    line-height: 49px;
    color: #4d4d4d;
    /* padding-top: 40px; */
    padding-left: 47px;
  }
  .chevron_left {
    display: flex;
    align-items: center;
    padding-left: 35px;
  }
  /* crumb */
  /* .crumb-selection{
    padding-left: 33px;
    padding-right: 31px;
  } */
  .crumb-trail {
    /* margin-top: 40px; */
    margin-bottom: 0px;
    list-style: none;
    /* padding: 0px 10px; */
  }
  .p-0 {
    padding: 0px;
  }
  .pl-8 {
    padding-left: 8px;
  }

  .p-40 {
    padding: 40px;
  }
  .completed_slide > .crumb > .breadcrumb-img {
    display: inline;
  }
  .breadcrumb-img {
    vertical-align: top;
    margin-right: 6px;
    height: 23px;
    width: 23px;
    display: none;
  }
  .crumb {
    font-weight: 400;
    color: #828282;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    padding: 22px 20px;
    position: relative;
    cursor: pointer;
    background: rgba(11, 60, 97, 0.1);
    text-align: center;
    z-index: 9;
  }
  .is-active-slide > .crumb {
    background: #01518a;
    color: #ffffff;
  }
  .crumb-trail > li.is-active-slide + li > .crumb:after {
    border-left-color: #01518a;
  }
  .pull-left {
    float: left;
  }
  .crumb-trail > li:first-child > .crumb {
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
  }
  .crumb-trail > li:last-child > .crumb {
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
  }
  .crumb-trail > li:not(:first-child) > .crumb {
    margin-left: 10px;
  }
  li:not(:first-child) > .crumb:after {
    content: '';
    border-top: 38px solid transparent;
    border-bottom: 33px solid transparent;
    border-left: 24px solid rgba(11, 60, 97, 0.1);
    position: absolute;
    left: -10px;
    top: 0;
    z-index: 1;
  }
  li:not(:first-child) > .crumb:before {
    content: '';
    border-top: 38px solid transparent;
    border-bottom: 33px solid transparent;
    border-left: 24px solid #fff;
    position: absolute;
    left: 0;
    top: 0;
  }
  .hide-xs {
    display: inline;
  }
  .show-xs {
    display: none;
  }
  /* .reg-details-note {
    font-weight: 700;
    font-size: 24px;
    line-height: 33px;
    color: #4d4d4d;
    margin: 28px 0px 8px 41px;
  } */
  .required-field-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #b00505;
  }

  .col-gap-56 {
    column-gap: 56px;
  }

  .mb-32 {
    margin-bottom: 32px;
  }
  .form-group {
    margin-bottom: 40px;
  }
  .not-approved-field .form-group {
    margin-bottom: 26px;
  }
  .form-group input::placeholder,
  .form-group textarea::placeholder {
    color: #999999;
    font-weight: 400;
  }
  .form-group .label_name {
    padding-left: 0px;
    margin-bottom: 7px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #3e3e3e;
    margin-left: 36px;
  }
  .form-group .field-section {
    padding-left: 0px;
    display: flex;
    align-items: flex-start;
  }
  /* .form-group.right {
    padding-left: 35px;
  } */
  .form-group.left {
    /* padding-right: 35px; */
  }
  .text-area .form-group.left {
    padding-right: 0px !important;
  }
  /* .form-group.right::v-deep .excel-popover {
    left: 27px !important;
  } */
  /* .form-group.left::v-deep .excel-popover {
    left: -8px !important;
  } */
  /* .description-section::v-deep .excel-popover,
  .comments-section::v-deep .excel-popover {
    top: 93px !important;
  } */
  .description-section textarea {
    position: relative;
  }
  .description-section textarea::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 50%;
    border-top: 2px solid red;
  }

  ::v-deep .excel-popover {
    left: -124px !important;
    top: 54px !important;
    z-index: 200000;
  }

  .custom-tooltip-record ::v-deep .excel-popover {
    left: -95px !important;
  }

  .attachments ::v-deep .excel-popover {
    /* left: -8px !important; */
    top: 30px !important;
  }
  .mb-44 {
    margin-bottom: 44px;
  }

  ::v-deep .v-select-part .dropdown-toggle {
    border: 1px solid #4d4d4d;
  }

  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__tags, .multiselect-single-dropdown.multiselect--disabled  >>> .multiselect__single  {
    background: #f3f3f3;
    cursor: not-allowed;
  }

  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__tags {
    border: 1px solid #4d4d4d;
  }

  /* .multiselect-single-dropdown.multiselect--disabled  >>> .multiselect__single {
    background: #f3f3f3;
    cursor: not-allowed;
  } */

  ::v-deep .multiselect-single-dropdown .multiselect__tags {
    border: 1px solid #4d4d4d;
  }

  .form-group .form-control {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #4d4d4d;
    margin-left: 12px;
    padding: 12px;
    /* padding-left: 12px;
    padding-top: 6px; */
    /* padding-bottom: 5px; */
    border: 1px solid #4d4d4d;
    border-radius: 3px;
    display: block;
    width: 100%;
    height: 44px;
    background-color: #fff !important;
  }
  textarea {
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    resize: none;
    color: #4d4d4d;
    margin-left: 17px;
    padding-left: 12px;
    padding-top: 6px;
    padding-bottom: 5px;
    border: 0.5px solid #000000;
    border-radius: 3px;
    display: block;
    width: 100%;
    height: 100px;
    background-color: #fff !important;
  }
  .asterisk:after {
    content: '*';
    font-size: 12px;
    color: #b00505;
    position: relative;
    top: -1px;
    margin-left: 2px;
  }
  .break-line {
    padding-left: 89px;
    padding-right: 26px;
    margin-bottom: 29px;
  }
  .break-line hr {
    margin: 0px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .light-blue-horizontal-line {
    border-top: 1px solid rgba(52, 17, 126, 0.1);
  }
  .remove_border {
    border-top: none;
  }
  /* input[type='checkbox'] {
    width: 18px;
    height: 18px;
    margin: 0px;
  } */
  .not-approved-text {
    /* top: 0px; */
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
    /* padding-left: 16px; */
    /* position: absolute; */
    /* left: 53px; */
  }
  /* footer  */
  .footer {
    /* z-index: 99; */
    padding: 59px 40px 24px 0px;
    position: fixed;
    bottom: 0%;
    right: 0;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 15;
  }
  .blue_outline_cancel_button,
  .blue_outline_cancel_button:hover {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: 1px solid #000000;
    padding: 10px 42px 9px 40px;
    min-width: 140px;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25) !important;
  }

  .blue_outline_back_button,
  .blue_outline_back_button:hover {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: 1px solid #000000;
    padding: 10px 42px 9px 40px;
    max-width: 140px;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25) !important;
  }

  .blue_save_button,
  .blue_save_button:hover,
  .blue_save_button:focus,
  .blue_next_button,
  .blue_next_button:hover,
  .blue_next_button:focus {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #01518a;
    border: 1px solid #01518a;
    border: none;
    padding: 10px 50px 9px 48px;
    cursor: pointer;
    min-width: 140px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25) !important;
  }
  /* Attachments  */
  .card-title p {
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
    margin-bottom: 0px;
  }
  .no-of-files-attached {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #4d4d4d;
    margin-top: 8px;
  }
  .panel-heading {
    /* padding-bottom: 15px;
    padding-top: 22px;
    padding-left: 29px; */
    padding: 15px 24px;
  }
  .panel-body {
    padding: 0px !important;
    margin-left: 56px;
    margin-right: 36px;
    margin-bottom: 39px;
  }
  .panel-body .file-name {
    /* padding-top: 14px;
    padding-bottom: 14px; */
    padding: 14px 14px 12px 24px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    color: #3e3e3e;
  }

  ::v-deep .v-select-part .open-indicator {
    left: 95% !important;
  }
  .panel-group .panel-collapse .panel-body {
    /* border-top: 0.5px solid #b4b4b4 !important; */
  }
  .panel-default>.panel-heading+.panel-collapse>.panel-body{
    border-top: 0;
  }

  .no-files-attached {
    height: 250px;
  }
  .no-files-attached p {
    font-weight: 400;
    /* padding-top: 75px; */
    /* padding-bottom: 113px; */
    font-size: 16px;
    line-height: 22px;
    /* text-align: center; */
    color: #333333;
    /* margin-bottom: 0px; */
  }
  .fileNamesRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 15px 14px 16px;
  }
  /* .uploaded-files-list{
    padding-left: 16px;
    padding-right: 16px;
  } */

  .form-group .field-section .form-control[disabled] {
    background-color: #f3f3f3 !important;
  }

  button[aria-expanded='true'] img.upCarret {
    display: inline-block;
    transform: rotate(180deg);
  }
  button[aria-expanded='true'] img.downCarret {
    display: none;
  }
  button img.downCarret {
    display: inline-block;
    /* transform: rotate(180deg); */
  }
  button img.upCarret {
    display: none;
  }

  .pl-28 {
    padding-left: 28px;
  }

  .form-group .description-flex-start, .form-group .comments-flex-start {
    align-items: flex-start;
  }
  @media screen and (max-width: 1300px) {
    ::v-deep .excel-popover {
    left: -12px !important;
    top: 54px !important;
  }

  .custom-tooltip-record >>> .excel-popover {
    left: 18px !important;
  }

  ::v-deep .excel-popover:after {
    left: 12px !important;
  }
    .attachments-footer-hr {
      margin-left: 50px;
      margin-right: -342px;
    }
    .addRecord-footer-hr {
      margin-left: 65px;
      margin-right: -426px;
    }
    .back-btn-position {
      position: absolute;
      left: 40px;
    }
  }
  ::v-deep .v-select-part input[type="search"],
  ::v-deep .v-select-part input[type="search"]:focus {
    height: 44px;
    font-weight: bold;
  }
  /* @media screen and (min-width: 1301px) and (max-width: 1399px){
  .product-class-ellipsis.multiselect-single-dropdown
  >>> .multiselect__single,
  .accredited-by-ellipsis.multiselect-single-dropdown
  >>> .multiselect__single{
    max-width: 344px;
  }
  }
  @media screen and (min-width: 1024px) and (max-width: 1300px){
  .product-class-ellipsis.multiselect-single-dropdown
  >>> .multiselect__single,
  .accredited-by-ellipsis.multiselect-single-dropdown
  >>> .multiselect__single{
    max-width: 200px;
  }
  } */
  @media only screen and (max-width: 991px) {
    .reg-popup .mx-datepicker {
      width: 144px;
    }
  }

  @media screen and (max-width: 768px) {
    .xs-flex-column {
      flex-direction: column;
    }
    .xs-pl-0 {
      padding-left: 0px;
    }
    .xs-pr-0 {
      padding-left: 0px;
    }
    .custom-tooltip-record >>> .excel-popover {
      left: -9px !important;
    }
  }
  @media (width: 768px) {
    .crumb > .breadcrumb-img {
      vertical-align: middle;
      margin-right: 2px;
      height: 18px;
      width: 18px;
    }
    .crumb-trail > li > .crumb {
      font-size: 15px;
      padding: 20px 5px 20px 28px;
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    .crumb-trail > li > .crumb {
      font-size: 16px;
      padding: 20px 0px 20px 28px;
    }
  }
  @media screen and (max-width: 1024px) {
    .crumb-trail > li:not(:first-child) > .crumb:after {
      left: -11px;
    }
    .crumb-trail > li:not(:last-child).is-active-slide > .crumb {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    .crumb-trail > li:not(:first-child) > .crumb:before {
      left: -1px;
    }
  }
  @media screen and (max-width: 767px) {
    .form-group.right {
      padding-left: 0;
    }
    .form-group.left {
      padding-right: 0;
    }
    .crumb-selection {
      padding: 0px;
    }
    .crumb-trail {
      padding: 0px;
    }
    .completed_slide > .crumb > .breadcrumb-img {
      margin-right: 0px;
      height: 30px;
      width: 30px;
    }
    .crumb-trail > li.completed_slide > .crumb {
      padding: 8px;
    }
    .crumb-trail > li:not(:first-child).completed_slide > .crumb {
      padding: 8px 0px 8px 0px;
      text-align: right;
    }
    .crumb-trail > li > .crumb {
      font-size: 0px;
      padding: 12px;
    }
    .crumb-trail > li.is-active-slide > .crumb {
      font-size: 16px;
    }
    .crumb-trail > li.is-active-slide + li > .crumb:after {
      border-left-color: #0b3c61;
    }
    .crumb-trail > li:not(:first-child) > .crumb:after {
      border-top: 22px solid transparent;
      border-bottom: 24px solid transparent;
      border-left: 16px solid #f3f5fb;
    }
    .crumb-trail > li:not(:first-child) > .crumb:before {
      border-top: 22px solid transparent;
      border-bottom: 25px solid transparent;
      border-left: 16px solid #fff;
    }
    .xs-flex-column {
      flex-direction: column;
      row-gap: 10px;
    }
  }
  @media screen and (max-width: 1300px) {
    .ml-230 {
      margin-left: 0;
    }
  }
  </style>
